var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInjectionUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1209,
    height: 564,
    viewBox: "0 0 1209 564",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M937.498 108.055V50.9364L925.725 38.1689H903.425L891.035 51.6056V108.724",
    fill: "url(#paint0_linear_2809_24943)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M905.649 32.0967H923.582C924.56 32.0967 925.366 32.9032 925.366 33.8814V37.4679H903.864V33.8814C903.864 32.9032 904.671 32.0967 905.649 32.0967Z",
    fill: "url(#paint1_linear_2809_24943)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M913.302 13.2949H914.554C916.056 13.2949 917.283 14.5219 917.283 16.0235V32.1114H910.564V16.0235C910.564 14.5219 911.791 13.2949 913.293 13.2949H913.31H913.302Z",
    fill: "url(#paint2_linear_2809_24943)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M953.537 70.4221V51.6056L965.927 38.1689H988.227L999.999 50.9364V71.0571",
    fill: "url(#paint3_linear_2809_24943)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M968.137 32.0967H986.07C987.048 32.0967 987.854 32.9032 987.854 33.8814V37.4679H966.352V33.8814C966.352 32.9032 967.159 32.0967 968.137 32.0967Z",
    fill: "url(#paint4_linear_2809_24943)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M975.803 13.2949H977.056C978.558 13.2949 979.784 14.5219 979.784 16.0235V32.1114H973.066V16.0235C973.066 14.5219 974.293 13.2949 975.795 13.2949H975.812H975.803Z",
    fill: "url(#paint5_linear_2809_24943)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.03 70.4221V51.6056L1028.42 38.1689H1050.72L1062.49 50.9364V71.0571",
    fill: "url(#paint6_linear_2809_24943)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.64 32.0967H1048.57C1049.55 32.0967 1050.36 32.9032 1050.36 33.8814V37.4679H1028.85V33.8814C1028.85 32.9032 1029.66 32.0967 1030.64 32.0967Z",
    fill: "url(#paint7_linear_2809_24943)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1038.3 13.2949H1039.55C1041.05 13.2949 1042.28 14.5219 1042.28 16.0235V32.1114H1035.56V16.0235C1035.56 14.5219 1036.79 13.2949 1038.29 13.2949H1038.31H1038.3Z",
    fill: "url(#paint8_linear_2809_24943)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124 302.579C130.847 302.579 136.398 297.028 136.398 290.181C136.398 283.333 130.847 277.782 124 277.782C117.152 277.782 111.601 283.333 111.601 290.181C111.601 297.028 117.152 302.579 124 302.579Z",
    fill: "url(#paint9_linear_2809_24943)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M921.792 108.727H891.023V134.261H876.282C876.282 134.261 888.578 133.446 893.082 163.829C895.562 180.578 889.075 197.412 889.075 197.412V216.34C889.075 217.164 888.861 217.953 888.475 218.665L807.631 364.341C807.228 365.053 807.031 365.86 807.031 366.666V387.714C807.031 390.365 809.167 392.501 811.819 392.501H1035.89C1037.41 392.501 1038.85 391.764 1039.75 390.537L1121.26 279.328C1121.86 278.504 1122.18 277.526 1122.18 276.505V264.046",
    fill: "#E4E2D7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M865.027 260.93H860.805C859.21 260.93 857.794 259.926 857.288 258.408L844.22 220.114C843.705 218.612 842.281 217.591 840.702 217.591H837.99L812.456 218.938H806.518C806.089 218.938 805.737 218.587 805.737 218.158V213.644C805.737 210.633 803.292 208.187 800.28 208.187H798.453C798.024 208.187 797.672 207.836 797.672 207.407V201.469H799.019L800.366 143.672V138.293H829.934V135.607H837.999V128.751C837.999 128.082 838.548 127.541 839.209 127.541H841.534C841.843 127.541 842.152 127.421 842.384 127.19L845.713 123.861C845.927 123.629 846.236 123.509 846.562 123.509H900.052L893.102 218.938L865.035 260.939L865.027 260.93Z",
    fill: "url(#paint10_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.83 456.018H1150.87V544.712C1150.87 554.957 1142.55 563.271 1132.31 563.271H224.39C214.145 563.271 205.83 554.948 205.83 544.712V456.018Z",
    fill: "url(#paint11_linear_2809_24943)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M679.83 375.959H1187.01C1188.46 375.959 1189.63 377.126 1189.63 378.576V390.468C1189.63 391.918 1190.79 393.085 1192.24 393.085H1206.38C1207.83 393.085 1209 394.252 1209 395.702V432.383C1209 433.833 1207.83 435 1206.38 435C1204.93 435 1203.77 436.167 1203.77 437.617V467.656C1203.77 468.351 1203.48 469.012 1203 469.51L1183.89 488.618C1183.4 489.115 1182.74 489.381 1182.04 489.381H1153.47C1152.02 489.381 1150.85 488.214 1150.85 486.764V458.604C1150.85 457.154 1149.68 455.987 1148.23 455.987L228.397 455.515H108.119C106.668 455.515 105.502 454.348 105.502 452.898V435.489C105.502 434.039 106.668 432.872 108.119 432.872H111.293C112.743 432.872 113.91 431.705 113.91 430.255V409.963C113.91 409.207 113.584 408.487 113.009 407.989L108.101 403.742C107.629 403.321 107.012 403.098 106.377 403.098H103.408C101.958 403.098 100.791 401.931 100.791 400.481V397.916C100.791 396.466 101.958 395.299 103.408 395.299H104.378C105.828 395.299 106.995 394.132 106.995 392.682V388.864C106.995 387.414 108.161 386.247 109.612 386.247H124.198C124.987 386.247 125.734 386.599 126.231 387.216L128.557 390.082C129.054 390.683 129.792 391.052 130.59 391.052H158.845C160.295 391.052 161.462 389.885 161.462 388.435V378.593C161.462 377.143 162.629 375.976 164.079 375.976H327.396",
    fill: "#9EACAC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.964 404.859H108.754",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M352.999 404.859H146.532",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.19 404.859H667.158",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1208.19 431.748H112.785",
    stroke: "#845B24",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.97 435.517H108.804C106.976 435.517 105.5 436.992 105.5 438.82V452.694C105.5 454.522 106.985 455.998 108.804 455.998H1147.97C1149.79 455.998 1151.27 454.513 1151.27 452.694V438.82C1151.27 436.992 1149.79 435.517 1147.97 435.517Z",
    fill: "#E4E2D7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.74 468.687C1181.42 468.687 1186.84 463.272 1186.84 456.588C1186.84 449.904 1181.42 444.49 1174.74 444.49C1168.05 444.49 1162.64 449.904 1162.64 456.588C1162.64 463.272 1168.05 468.687 1174.74 468.687Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.503 426.759C146.187 426.759 151.602 421.345 151.602 414.661C151.602 407.977 146.187 402.562 139.503 402.562C132.819 402.562 127.405 407.977 127.405 414.661C127.405 421.345 132.819 426.759 139.503 426.759Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M356.816 413.944H663.105C665.285 413.944 667.044 412.186 667.044 410.006V391.07C667.044 388.89 668.803 387.131 670.982 387.131H676.508C678.687 387.131 680.446 385.372 680.446 383.193V376.234C680.446 374.055 678.687 372.296 676.508 372.296H331.513C329.333 372.296 327.574 374.055 327.574 376.234V381.76C327.574 383.939 329.333 385.698 331.513 385.698H348.519C350.672 385.698 352.414 387.423 352.457 389.559L352.878 410.083C352.921 412.237 354.68 413.944 356.816 413.944Z",
    fill: "url(#paint12_linear_2809_24943)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M352.501 240.303C353.05 235.944 356.774 232.572 361.278 232.572H365.243V229.423C365.243 227.767 366.59 226.429 368.237 226.429H488.867C490.883 226.429 492.522 228.068 492.522 230.084C492.522 231.405 493.595 232.478 494.916 232.478H531.957L531.339 347.273H519.164C507.769 347.273 498.537 356.505 498.537 367.9V372.928H366.444V358.247C366.444 351.108 360.661 345.334 353.531 345.334H352.398V265.006",
    fill: "#E4E2D7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M531.716 231.904H496.528C495.584 231.904 495.104 230.763 495.773 230.094L507.322 218.545H531.947L531.707 231.904H531.724H531.716Z",
    fill: "url(#paint13_linear_2809_24943)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M531.716 360.392H496.528C495.584 360.392 495.104 359.251 495.773 358.581L507.322 347.032H531.947L531.707 360.392H531.724H531.716Z",
    fill: "url(#paint14_linear_2809_24943)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M532.068 224.289H618.205V235.486H531.733L532.068 224.289Z",
    fill: "url(#paint15_linear_2809_24943)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M532.068 241.871H618.205V254.81H531.733L532.068 241.871Z",
    fill: "url(#paint16_linear_2809_24943)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M532.068 322.491H618.205V335.121H531.733L532.068 322.491Z",
    fill: "url(#paint17_linear_2809_24943)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M618.224 223.387V344C618.224 346.274 620.068 348.127 622.351 348.127H656.208C658.482 348.127 660.336 346.283 660.336 344V235.589C660.336 233.315 658.491 231.461 656.208 231.461H651.918C649.645 231.461 647.791 229.617 647.791 227.334V223.37C647.791 221.096 645.946 219.243 643.664 219.243H622.351C620.077 219.243 618.224 221.088 618.224 223.37V223.387Z",
    fill: "url(#paint18_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M661.723 238.556H672.097C673.169 238.556 674.045 239.432 674.045 240.504V240.641C674.045 241.714 674.92 242.589 675.992 242.589H676.378C677.451 242.589 678.326 243.464 678.326 244.537V256.24C678.326 257.313 677.451 258.188 676.378 258.188C675.306 258.188 674.431 259.063 674.431 260.136V262.341C674.431 263.413 673.556 264.289 672.483 264.289H661.929C660.857 264.289 659.99 263.431 659.982 262.367C659.93 257.605 659.81 245.326 659.767 240.513C659.767 239.423 660.625 238.548 661.715 238.548L661.723 238.556Z",
    fill: "url(#paint19_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M661.723 313.828H672.097C673.169 313.828 674.045 314.703 674.045 315.776V315.913C674.045 316.985 674.92 317.861 675.992 317.861H676.378C677.451 317.861 678.326 318.736 678.326 319.808V331.512C678.326 332.584 677.451 333.46 676.378 333.46C675.306 333.46 674.431 334.335 674.431 335.407V337.612C674.431 338.685 673.556 339.56 672.483 339.56H661.929C660.857 339.56 659.99 338.702 659.982 337.638C659.93 332.876 659.81 320.598 659.767 315.784C659.767 314.695 660.625 313.819 661.715 313.819L661.723 313.828Z",
    fill: "url(#paint20_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M484.14 239.404H382.25V343.243H484.14V239.404Z",
    fill: "#E4E2D7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M479.839 244.238C479.839 244.753 479.427 245.165 478.913 245.165C478.398 245.165 477.986 244.753 477.986 244.238C477.986 243.723 478.398 243.312 478.913 243.312C479.427 243.312 479.839 243.723 479.839 244.238Z",
    fill: "#212120",
    stroke: "#333333",
    strokeWidth: 1.57
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M479.839 336.977C479.839 337.492 479.427 337.904 478.913 337.904C478.398 337.904 477.986 337.492 477.986 336.977C477.986 336.463 478.398 336.051 478.913 336.051C479.427 336.051 479.839 336.463 479.839 336.977Z",
    fill: "#212120",
    stroke: "#333333",
    strokeWidth: 1.57
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M387.094 244.238C387.094 244.753 386.682 245.165 386.167 245.165C385.652 245.165 385.24 244.753 385.24 244.238C385.24 243.723 385.652 243.312 386.167 243.312C386.682 243.312 387.094 243.723 387.094 244.238Z",
    fill: "#212120",
    stroke: "#333333",
    strokeWidth: 1.57
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M387.094 336.977C387.094 337.492 386.682 337.904 386.167 337.904C385.652 337.904 385.24 337.492 385.24 336.977C385.24 336.463 385.652 336.051 386.167 336.051C386.682 336.051 387.094 336.463 387.094 336.977Z",
    fill: "#212120",
    stroke: "#333333",
    strokeWidth: 1.57
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M368.914 244.451V239.071H378.318V264.606H368.914V259.226H348.75V244.443H368.914V244.451Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M355.788 240.091H352.064C351.661 240.091 351.283 239.928 351 239.645L345.328 233.974C345.045 233.69 344.668 233.527 344.264 233.527H338.001V268.629H345.448C345.852 268.629 346.229 268.466 346.512 268.183L349.661 265.034C349.944 264.751 350.322 264.588 350.725 264.588H355.487",
    fill: "url(#paint21_linear_2809_24943)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M338 237.742H207.632V264.624H338V237.742Z",
    fill: "url(#paint22_linear_2809_24943)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.901 268.667H205.976C206.894 268.667 207.64 267.921 207.64 267.003V235.393C207.64 234.475 206.894 233.729 205.976 233.729H199.901C198.983 233.729 198.236 234.475 198.236 235.393V267.003C198.236 267.921 198.983 268.667 199.901 268.667Z",
    fill: "url(#paint23_linear_2809_24943)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M195.603 240.454H196.838C197.611 240.454 198.237 239.827 198.237 239.055V237.819C198.237 237.047 197.611 236.421 196.838 236.421H195.603C194.831 236.421 194.204 237.047 194.204 237.819V239.055C194.204 239.827 194.831 240.454 195.603 240.454Z",
    fill: "url(#paint24_linear_2809_24943)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M193.183 257.913H196.572C197.491 257.913 198.237 257.167 198.237 256.249V246.141C198.237 245.223 197.491 244.477 196.572 244.477H193.183C192.265 244.477 191.519 245.223 191.519 246.141V256.249C191.519 257.167 192.265 257.913 193.183 257.913Z",
    fill: "url(#paint25_linear_2809_24943)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M114.906 256.555H191.519V245.804H114.906V256.555Z",
    fill: "url(#paint26_linear_2809_24943)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M113.043 244.463H91.2148C90.1937 244.463 89.3615 245.295 89.3615 246.316V256.046C89.3615 257.076 90.1937 257.9 91.2148 257.9H113.043C114.064 257.9 114.896 257.067 114.896 256.046V246.316C114.896 245.295 114.064 244.463 113.043 244.463Z",
    fill: "url(#paint27_linear_2809_24943)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M195.603 267.335H196.838C197.611 267.335 198.237 266.709 198.237 265.937V264.701C198.237 263.929 197.611 263.303 196.838 263.303H195.603C194.831 263.303 194.204 263.929 194.204 264.701V265.937C194.204 266.709 194.831 267.335 195.603 267.335Z",
    fill: "url(#paint28_linear_2809_24943)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M101.45 244.704V238.938C101.45 238.278 100.927 237.754 100.266 237.754H99.9402C99.2795 237.754 98.7561 237.231 98.7561 236.57V234.906C98.7561 234.245 98.2328 233.722 97.5721 233.722H90.5277C89.867 233.722 89.3436 234.245 89.3436 234.906V236.57C89.3436 237.231 88.8202 237.754 88.1595 237.754H87.8335C87.1728 237.754 86.6494 238.278 86.6494 238.938V263.452C86.6494 264.113 87.1728 264.636 87.8335 264.636H89.4981C90.1587 264.636 90.6821 265.16 90.6821 265.82V267.485C90.6821 268.146 91.2055 268.669 91.8662 268.669H96.225C96.8857 268.669 97.4091 268.146 97.4091 267.485V265.82C97.4091 265.16 97.9324 264.636 98.5931 264.636H100.258C100.918 264.636 101.442 264.113 101.442 263.452V258.201",
    fill: "url(#paint29_linear_2809_24943)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8685 237.749L81.502 231.382C81.3304 231.211 81.0987 231.116 80.8585 231.116H78.1815C77.6838 231.116 77.2805 231.519 77.2805 232.017V269.101C77.2805 269.599 77.6838 270.002 78.1815 270.002H80.9357C81.176 270.002 81.4076 269.908 81.5792 269.736L86.9848 264.33",
    fill: "url(#paint30_linear_2809_24943)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M362.198 270H358.689C358.405 270 358.165 269.768 358.165 269.477V267.821C358.165 267.538 357.933 267.297 357.642 267.297H355.986C355.703 267.297 355.462 267.066 355.462 266.774V259.326",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M362.198 235.044H358.689C358.405 235.044 358.165 235.276 358.165 235.567V237.223C358.165 237.506 357.933 237.747 357.642 237.747H355.986C355.703 237.747 355.462 237.978 355.462 238.27V244.465",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M365.55 244.604V238.263C365.55 237.98 365.319 237.74 365.027 237.74H363.371C363.088 237.74 362.847 237.508 362.847 237.217V235.561C362.847 235.277 362.616 235.037 362.324 235.037H358.815",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M358.832 270.002H362.341C362.624 270.002 362.865 269.77 362.865 269.478V267.822C362.865 267.539 363.096 267.299 363.388 267.299H365.044C365.327 267.299 365.568 267.067 365.568 266.776V259.56",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M368.914 321.087V315.707H378.318V341.242H368.914V335.862H348.75V321.078H368.914V321.087Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M355.788 316.727H352.064C351.661 316.727 351.283 316.564 351 316.281L345.328 310.609C345.045 310.326 344.668 310.163 344.264 310.163H338.001V345.265H345.448C345.852 345.265 346.229 345.102 346.512 344.819L349.661 341.67C349.944 341.387 350.322 341.224 350.725 341.224H355.487",
    fill: "url(#paint31_linear_2809_24943)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M338 314.342H207.632V341.224H338V314.342Z",
    fill: "url(#paint32_linear_2809_24943)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M199.901 345.273H205.976C206.894 345.273 207.64 344.526 207.64 343.608V311.999C207.64 311.08 206.894 310.334 205.976 310.334H199.901C198.983 310.334 198.236 311.08 198.236 311.999V343.608C198.236 344.526 198.983 345.273 199.901 345.273Z",
    fill: "url(#paint33_linear_2809_24943)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M195.603 317.053H196.838C197.611 317.053 198.237 316.427 198.237 315.655V314.419C198.237 313.647 197.611 313.021 196.838 313.021H195.603C194.831 313.021 194.204 313.647 194.204 314.419V315.655C194.204 316.427 194.831 317.053 195.603 317.053Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M193.183 334.518H196.572C197.491 334.518 198.237 333.771 198.237 332.853V322.746C198.237 321.828 197.491 321.081 196.572 321.081H193.183C192.265 321.081 191.519 321.828 191.519 322.746V332.853C191.519 333.771 192.265 334.518 193.183 334.518Z",
    fill: "url(#paint34_linear_2809_24943)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M114.906 333.19H191.519V322.439H114.906V333.19Z",
    fill: "url(#paint35_linear_2809_24943)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M113.043 321.068H91.2148C90.1937 321.068 89.3615 321.901 89.3615 322.922V332.652C89.3615 333.681 90.1937 334.505 91.2148 334.505H113.043C114.064 334.505 114.896 333.673 114.896 332.652V322.922C114.896 321.901 114.064 321.068 113.043 321.068Z",
    fill: "url(#paint36_linear_2809_24943)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.603 343.941H196.838C197.611 343.941 198.237 343.315 198.237 342.542V341.307C198.237 340.535 197.611 339.908 196.838 339.908H195.603C194.831 339.908 194.204 340.535 194.204 341.307V342.542C194.204 343.315 194.831 343.941 195.603 343.941Z",
    fill: "url(#paint37_linear_2809_24943)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M101.45 321.31V315.544C101.45 314.883 100.927 314.36 100.266 314.36H99.9402C99.2795 314.36 98.7561 313.836 98.7561 313.176V311.511C98.7561 310.85 98.2328 310.327 97.5721 310.327H90.5277C89.867 310.327 89.3436 310.85 89.3436 311.511V313.176C89.3436 313.836 88.8202 314.36 88.1595 314.36H87.8335C87.1728 314.36 86.6494 314.883 86.6494 315.544V340.058C86.6494 340.718 87.1728 341.242 87.8335 341.242H89.4981C90.1587 341.242 90.6821 341.765 90.6821 342.426V344.09C90.6821 344.751 91.2055 345.275 91.8662 345.275H96.225C96.8857 345.275 97.4091 344.751 97.4091 344.09V342.426C97.4091 341.765 97.9324 341.242 98.5931 341.242H100.258C100.918 341.242 101.442 340.718 101.442 340.058V334.807",
    fill: "url(#paint38_linear_2809_24943)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8685 314.348L81.502 307.982C81.3304 307.81 81.0987 307.716 80.8585 307.716H78.1815C77.6838 307.716 77.2805 308.119 77.2805 308.617V345.701C77.2805 346.198 77.6838 346.602 78.1815 346.602H80.9357C81.176 346.602 81.4076 346.507 81.5792 346.336L86.9848 340.93",
    fill: "url(#paint39_linear_2809_24943)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M362.198 346.605H358.689C358.405 346.605 358.165 346.374 358.165 346.082V344.426C358.165 344.143 357.933 343.903 357.642 343.903H355.986C355.703 343.903 355.462 343.671 355.462 343.379V335.932",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M362.198 311.649H358.689C358.405 311.649 358.165 311.881 358.165 312.173V313.829C358.165 314.112 357.933 314.352 357.642 314.352H355.986C355.703 314.352 355.462 314.584 355.462 314.876V321.071",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M365.55 321.21V314.869C365.55 314.586 365.319 314.345 365.027 314.345H363.371C363.088 314.345 362.847 314.114 362.847 313.822V312.166C362.847 311.883 362.616 311.643 362.324 311.643H358.815",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M358.832 346.607H362.341C362.624 346.607 362.865 346.376 362.865 346.084V344.428C362.865 344.145 363.096 343.904 363.388 343.904H365.044C365.327 343.904 365.568 343.673 365.568 343.381V336.165",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.31 70.4121H921.983V98.6326H1130.31V70.4121Z",
    fill: "#3385AE"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M865.95 142.853C868.044 140.27 870.438 138.812 872.977 138.812C881.146 138.812 887.787 153.93 887.787 172.575C887.787 191.22 881.163 206.338 872.977 206.338C870.669 206.338 868.49 205.128 866.542 202.975",
    fill: "url(#paint40_linear_2809_24943)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M865.95 142.853C868.044 140.27 870.438 138.812 872.977 138.812C881.146 138.812 887.787 153.93 887.787 172.575C887.787 191.22 881.163 206.338 872.977 206.338C870.669 206.338 868.49 205.128 866.542 202.975",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.17 267.695H1126.53C1128.26 267.695 1129.65 269.094 1129.65 270.81V362.327C1129.65 364.052 1128.25 365.442 1126.53 365.442H1058.42",
    fill: "#9EACAC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M837.981 207.781V220.711C837.981 221.226 837.561 221.638 837.055 221.638H813.373C812.858 221.638 812.446 221.218 812.446 220.711V209.128C812.446 208.613 812.026 208.201 811.52 208.201H806.655C806.14 208.201 805.728 207.781 805.728 207.275V203.714C805.728 203.199 806.149 202.787 806.655 202.787H822.271C822.786 202.787 823.197 203.208 823.197 203.714V205.927C823.197 206.442 823.618 206.854 824.124 206.854H837.055C837.569 206.854 837.981 207.275 837.981 207.781Z",
    fill: "url(#paint41_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M794.596 206.843H796.715C797.239 206.843 797.668 206.414 797.668 205.891V203.772C797.668 203.248 797.239 202.819 796.715 202.819H794.596C794.073 202.819 793.644 203.248 793.644 203.772V205.891C793.644 206.414 794.073 206.843 794.596 206.843Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M844.237 220.106V203.065H837.99",
    fill: "url(#paint42_linear_2809_24943)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M844.237 220.106V203.065H837.99",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M853.666 197.605V236.405C853.666 236.405 855.451 214.903 868.896 214.903H893.384L895.237 196.652L853.675 197.605H853.666Z",
    fill: "url(#paint43_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M869.377 203.77V214.521V203.77Z",
    fill: "url(#paint44_linear_2809_24943)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M869.377 203.77V214.521",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M851.428 143.66V138.28L849.412 136.264V127.529L870.245 131.562V136.255",
    fill: "url(#paint45_linear_2809_24943)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M851.428 143.66V138.28L849.412 136.264V127.529L870.245 131.562V136.255",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M849.412 127.529H899.984H849.412Z",
    fill: "url(#paint46_linear_2809_24943)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M849.412 127.529H899.984",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M870.244 131.557H899.811H870.244Z",
    fill: "url(#paint47_linear_2809_24943)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M870.244 131.557H899.811",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M787.879 156.092H798.346V183.978H787.879C786.24 183.978 784.91 182.648 784.91 181.009V159.078C784.91 157.439 786.24 156.109 787.879 156.109V156.092Z",
    fill: "url(#paint48_linear_2809_24943)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M210.385 237.406L338.008 237.74V226.44H408.238L423.356 212.206H797.669L799.017 200.107H210.385V237.406Z",
    fill: "#3385AE"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M330.476 264.719V314.175",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M148.498 308.986H141.78V322.423H148.498V308.986Z",
    fill: "url(#paint49_linear_2809_24943)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M148.498 256.575H141.78V270.012H148.498V256.575Z",
    fill: "url(#paint50_linear_2809_24943)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M841.036 117.141V119.466L837.5 123.018V135.597",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M880.883 247.327H1130.08V256.019H876.961",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M115.334 245.491L142.165 195.691L135.781 189.29L153.868 142.305H799.001V200.101H167.314L161.934 210.852H155.216L139.085 245.8L115.334 245.491Z",
    fill: "#56A3D2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M115.334 245.491L142.165 195.691L155.216 210.853L139.085 245.8L115.334 245.491Z",
    fill: "#56A3D2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M328.595 132.567C328.595 133.125 328.141 133.571 327.592 133.571C327.042 133.571 326.588 133.116 326.588 132.567C326.588 132.018 327.042 131.563 327.592 131.563C328.141 131.563 328.595 132.018 328.595 132.567Z",
    fill: "url(#paint51_linear_2809_24943)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M332.63 136.588C332.63 137.146 332.176 137.592 331.627 137.592C331.077 137.592 330.623 137.146 330.623 136.588C330.623 136.03 331.077 135.584 331.627 135.584C332.176 135.584 332.63 136.039 332.63 136.588Z",
    fill: "url(#paint52_linear_2809_24943)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M333.966 132.567C333.966 133.125 333.512 133.571 332.962 133.571C332.413 133.571 331.958 133.116 331.958 132.567C331.958 132.018 332.413 131.563 332.962 131.563C333.512 131.563 333.966 132.018 333.966 132.567Z",
    fill: "url(#paint53_linear_2809_24943)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M338.001 136.588C338.001 137.146 337.546 137.592 336.997 137.592C336.448 137.592 335.993 137.146 335.993 136.588C335.993 136.03 336.448 135.584 336.997 135.584C337.546 135.584 338.001 136.039 338.001 136.588Z",
    fill: "url(#paint54_linear_2809_24943)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M340.693 132.567C340.693 133.125 340.238 133.571 339.689 133.571C339.14 133.571 338.685 133.116 338.685 132.567C338.685 132.018 339.14 131.563 339.689 131.563C340.238 131.563 340.693 132.018 340.693 132.567Z",
    fill: "url(#paint55_linear_2809_24943)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M344.721 136.588C344.721 137.146 344.266 137.592 343.717 137.592C343.168 137.592 342.713 137.146 342.713 136.588C342.713 136.03 343.168 135.584 343.717 135.584C344.266 135.584 344.721 136.039 344.721 136.588Z",
    fill: "url(#paint56_linear_2809_24943)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M300.366 132.567C300.366 133.125 299.912 133.571 299.363 133.571C298.813 133.571 298.359 133.116 298.359 132.567C298.359 132.018 298.813 131.563 299.363 131.563C299.912 131.563 300.366 132.018 300.366 132.567Z",
    fill: "url(#paint57_linear_2809_24943)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M304.401 136.588C304.401 137.146 303.946 137.592 303.397 137.592C302.847 137.592 302.393 137.146 302.393 136.588C302.393 136.03 302.847 135.584 303.397 135.584C303.946 135.584 304.401 136.039 304.401 136.588Z",
    fill: "url(#paint58_linear_2809_24943)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M307.093 132.567C307.093 133.125 306.638 133.571 306.089 133.571C305.54 133.571 305.085 133.116 305.085 132.567C305.085 132.018 305.54 131.563 306.089 131.563C306.638 131.563 307.093 132.018 307.093 132.567Z",
    fill: "url(#paint59_linear_2809_24943)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M311.121 136.588C311.121 137.146 310.666 137.592 310.117 137.592C309.568 137.592 309.113 137.146 309.113 136.588C309.113 136.03 309.568 135.584 310.117 135.584C310.666 135.584 311.121 136.039 311.121 136.588Z",
    fill: "url(#paint60_linear_2809_24943)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M348.751 132.567C348.751 133.125 348.296 133.571 347.747 133.571C347.198 133.571 346.743 133.116 346.743 132.567C346.743 132.018 347.198 131.563 347.747 131.563C348.296 131.563 348.751 132.018 348.751 132.567Z",
    fill: "url(#paint61_linear_2809_24943)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M352.784 136.588C352.784 137.146 352.329 137.592 351.78 137.592C351.231 137.592 350.776 137.146 350.776 136.588C350.776 136.03 351.231 135.584 351.78 135.584C352.329 135.584 352.784 136.039 352.784 136.588Z",
    fill: "url(#paint62_linear_2809_24943)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M355.477 132.567C355.477 133.125 355.022 133.571 354.473 133.571C353.924 133.571 353.469 133.116 353.469 132.567C353.469 132.018 353.924 131.563 354.473 131.563C355.022 131.563 355.477 132.018 355.477 132.567Z",
    fill: "url(#paint63_linear_2809_24943)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M359.511 136.588C359.511 137.146 359.056 137.592 358.507 137.592C357.958 137.592 357.503 137.146 357.503 136.588C357.503 136.03 357.958 135.584 358.507 135.584C359.056 135.584 359.511 136.039 359.511 136.588Z",
    fill: "url(#paint64_linear_2809_24943)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M360.848 132.567C360.848 133.125 360.393 133.571 359.844 133.571C359.295 133.571 358.84 133.116 358.84 132.567C358.84 132.018 359.295 131.563 359.844 131.563C360.393 131.563 360.848 132.018 360.848 132.567Z",
    fill: "url(#paint65_linear_2809_24943)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M364.881 136.588C364.881 137.146 364.427 137.592 363.877 137.592C363.328 137.592 362.874 137.146 362.874 136.588C362.874 136.03 363.328 135.584 363.877 135.584C364.427 135.584 364.881 136.039 364.881 136.588Z",
    fill: "url(#paint66_linear_2809_24943)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M367.567 132.567C367.567 133.125 367.112 133.571 366.563 133.571C366.014 133.571 365.559 133.116 365.559 132.567C365.559 132.018 366.014 131.563 366.563 131.563C367.112 131.563 367.567 132.018 367.567 132.567Z",
    fill: "url(#paint67_linear_2809_24943)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M371.602 136.588C371.602 137.146 371.147 137.592 370.598 137.592C370.049 137.592 369.594 137.146 369.594 136.588C369.594 136.03 370.049 135.584 370.598 135.584C371.147 135.584 371.602 136.039 371.602 136.588Z",
    fill: "url(#paint68_linear_2809_24943)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M375.634 132.567C375.634 133.125 375.179 133.571 374.63 133.571C374.08 133.571 373.626 133.116 373.626 132.567C373.626 132.018 374.08 131.563 374.63 131.563C375.179 131.563 375.634 132.018 375.634 132.567Z",
    fill: "url(#paint69_linear_2809_24943)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M379.664 136.588C379.664 137.146 379.209 137.592 378.66 137.592C378.111 137.592 377.656 137.146 377.656 136.588C377.656 136.03 378.111 135.584 378.66 135.584C379.209 135.584 379.664 136.039 379.664 136.588Z",
    fill: "url(#paint70_linear_2809_24943)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M382.35 132.567C382.35 133.125 381.895 133.571 381.346 133.571C380.797 133.571 380.342 133.116 380.342 132.567C380.342 132.018 380.797 131.563 381.346 131.563C381.895 131.563 382.35 132.018 382.35 132.567Z",
    fill: "url(#paint71_linear_2809_24943)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M386.384 136.588C386.384 137.146 385.93 137.592 385.381 137.592C384.831 137.592 384.377 137.146 384.377 136.588C384.377 136.03 384.831 135.584 385.381 135.584C385.93 135.584 386.384 136.039 386.384 136.588Z",
    fill: "url(#paint72_linear_2809_24943)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M387.734 132.567C387.734 133.125 387.279 133.571 386.73 133.571C386.181 133.571 385.726 133.116 385.726 132.567C385.726 132.018 386.181 131.563 386.73 131.563C387.279 131.563 387.734 132.018 387.734 132.567Z",
    fill: "url(#paint73_linear_2809_24943)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M391.763 136.588C391.763 137.146 391.308 137.592 390.759 137.592C390.21 137.592 389.755 137.146 389.755 136.588C389.755 136.03 390.21 135.584 390.759 135.584C391.308 135.584 391.763 136.039 391.763 136.588Z",
    fill: "url(#paint74_linear_2809_24943)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M394.447 132.567C394.447 133.125 393.992 133.571 393.443 133.571C392.894 133.571 392.439 133.116 392.439 132.567C392.439 132.018 392.894 131.563 393.443 131.563C393.992 131.563 394.447 132.018 394.447 132.567Z",
    fill: "url(#paint75_linear_2809_24943)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M398.482 136.588C398.482 137.146 398.027 137.592 397.478 137.592C396.929 137.592 396.474 137.146 396.474 136.588C396.474 136.03 396.929 135.584 397.478 135.584C398.027 135.584 398.482 136.039 398.482 136.588Z",
    fill: "url(#paint76_linear_2809_24943)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M402.517 132.567C402.517 133.125 402.062 133.571 401.513 133.571C400.964 133.571 400.509 133.116 400.509 132.567C400.509 132.018 400.964 131.563 401.513 131.563C402.062 131.563 402.517 132.018 402.517 132.567Z",
    fill: "url(#paint77_linear_2809_24943)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M406.546 136.588C406.546 137.146 406.091 137.592 405.542 137.592C404.993 137.592 404.538 137.146 404.538 136.588C404.538 136.03 404.993 135.584 405.542 135.584C406.091 135.584 406.546 136.039 406.546 136.588Z",
    fill: "url(#paint78_linear_2809_24943)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M409.237 132.567C409.237 133.125 408.782 133.571 408.233 133.571C407.683 133.571 407.229 133.116 407.229 132.567C407.229 132.018 407.683 131.563 408.233 131.563C408.782 131.563 409.237 132.018 409.237 132.567Z",
    fill: "url(#paint79_linear_2809_24943)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M413.264 136.588C413.264 137.146 412.81 137.592 412.261 137.592C411.711 137.592 411.257 137.146 411.257 136.588C411.257 136.03 411.711 135.584 412.261 135.584C412.81 135.584 413.264 136.039 413.264 136.588Z",
    fill: "url(#paint80_linear_2809_24943)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M414.614 132.567C414.614 133.125 414.159 133.571 413.61 133.571C413.061 133.571 412.606 133.116 412.606 132.567C412.606 132.018 413.061 131.563 413.61 131.563C414.159 131.563 414.614 132.018 414.614 132.567Z",
    fill: "url(#paint81_linear_2809_24943)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M418.648 136.588C418.648 137.146 418.194 137.592 417.645 137.592C417.095 137.592 416.641 137.146 416.641 136.588C416.641 136.03 417.095 135.584 417.645 135.584C418.194 135.584 418.648 136.039 418.648 136.588Z",
    fill: "url(#paint82_linear_2809_24943)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M421.334 132.567C421.334 133.125 420.879 133.571 420.33 133.571C419.781 133.571 419.326 133.116 419.326 132.567C419.326 132.018 419.781 131.563 420.33 131.563C420.879 131.563 421.334 132.018 421.334 132.567Z",
    fill: "url(#paint83_linear_2809_24943)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M425.362 136.588C425.362 137.146 424.908 137.592 424.358 137.592C423.809 137.592 423.354 137.146 423.354 136.588C423.354 136.03 423.809 135.584 424.358 135.584C424.908 135.584 425.362 136.039 425.362 136.588Z",
    fill: "url(#paint84_linear_2809_24943)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M429.397 132.567C429.397 133.125 428.942 133.571 428.393 133.571C427.844 133.571 427.389 133.116 427.389 132.567C427.389 132.018 427.844 131.563 428.393 131.563C428.942 131.563 429.397 132.018 429.397 132.567Z",
    fill: "url(#paint85_linear_2809_24943)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M433.432 136.588C433.432 137.146 432.977 137.592 432.428 137.592C431.879 137.592 431.424 137.146 431.424 136.588C431.424 136.03 431.879 135.584 432.428 135.584C432.977 135.584 433.432 136.039 433.432 136.588Z",
    fill: "url(#paint86_linear_2809_24943)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M436.117 132.567C436.117 133.125 435.662 133.571 435.113 133.571C434.564 133.571 434.109 133.116 434.109 132.567C434.109 132.018 434.564 131.563 435.113 131.563C435.662 131.563 436.117 132.018 436.117 132.567Z",
    fill: "url(#paint87_linear_2809_24943)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M440.147 136.588C440.147 137.146 439.692 137.592 439.143 137.592C438.594 137.592 438.139 137.146 438.139 136.588C438.139 136.03 438.594 135.584 439.143 135.584C439.692 135.584 440.147 136.039 440.147 136.588Z",
    fill: "url(#paint88_linear_2809_24943)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M441.494 132.567C441.494 133.125 441.04 133.571 440.49 133.571C439.941 133.571 439.487 133.116 439.487 132.567C439.487 132.018 439.941 131.563 440.49 131.563C441.04 131.563 441.494 132.018 441.494 132.567Z",
    fill: "url(#paint89_linear_2809_24943)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M445.529 136.588C445.529 137.146 445.074 137.592 444.525 137.592C443.976 137.592 443.521 137.146 443.521 136.588C443.521 136.03 443.976 135.584 444.525 135.584C445.074 135.584 445.529 136.039 445.529 136.588Z",
    fill: "url(#paint90_linear_2809_24943)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M448.215 132.567C448.215 133.125 447.76 133.571 447.211 133.571C446.662 133.571 446.207 133.116 446.207 132.567C446.207 132.018 446.662 131.563 447.211 131.563C447.76 131.563 448.215 132.018 448.215 132.567Z",
    fill: "url(#paint91_linear_2809_24943)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M452.249 136.588C452.249 137.146 451.795 137.592 451.245 137.592C450.696 137.592 450.241 137.146 450.241 136.588C450.241 136.03 450.696 135.584 451.245 135.584C451.795 135.584 452.249 136.039 452.249 136.588Z",
    fill: "url(#paint92_linear_2809_24943)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M456.277 132.567C456.277 133.125 455.822 133.571 455.273 133.571C454.724 133.571 454.269 133.116 454.269 132.567C454.269 132.018 454.724 131.563 455.273 131.563C455.822 131.563 456.277 132.018 456.277 132.567Z",
    fill: "url(#paint93_linear_2809_24943)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M460.312 136.588C460.312 137.146 459.857 137.592 459.308 137.592C458.759 137.592 458.304 137.146 458.304 136.588C458.304 136.03 458.759 135.584 459.308 135.584C459.857 135.584 460.312 136.039 460.312 136.588Z",
    fill: "url(#paint94_linear_2809_24943)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M462.997 132.567C462.997 133.125 462.543 133.571 461.993 133.571C461.444 133.571 460.99 133.116 460.99 132.567C460.99 132.018 461.444 131.563 461.993 131.563C462.543 131.563 462.997 132.018 462.997 132.567Z",
    fill: "url(#paint95_linear_2809_24943)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M467.032 136.588C467.032 137.146 466.577 137.592 466.028 137.592C465.479 137.592 465.024 137.146 465.024 136.588C465.024 136.03 465.479 135.584 466.028 135.584C466.577 135.584 467.032 136.039 467.032 136.588Z",
    fill: "url(#paint96_linear_2809_24943)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M468.374 132.567C468.374 133.125 467.92 133.571 467.371 133.571C466.821 133.571 466.367 133.116 466.367 132.567C466.367 132.018 466.821 131.563 467.371 131.563C467.92 131.563 468.374 132.018 468.374 132.567Z",
    fill: "url(#paint97_linear_2809_24943)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M472.403 136.588C472.403 137.146 471.948 137.592 471.399 137.592C470.85 137.592 470.395 137.146 470.395 136.588C470.395 136.03 470.85 135.584 471.399 135.584C471.948 135.584 472.403 136.039 472.403 136.588Z",
    fill: "url(#paint98_linear_2809_24943)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M475.095 132.567C475.095 133.125 474.64 133.571 474.091 133.571C473.542 133.571 473.087 133.116 473.087 132.567C473.087 132.018 473.542 131.563 474.091 131.563C474.64 131.563 475.095 132.018 475.095 132.567Z",
    fill: "url(#paint99_linear_2809_24943)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M479.129 136.588C479.129 137.146 478.675 137.592 478.125 137.592C477.576 137.592 477.122 137.146 477.122 136.588C477.122 136.03 477.576 135.584 478.125 135.584C478.675 135.584 479.129 136.039 479.129 136.588Z",
    fill: "url(#paint100_linear_2809_24943)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M483.16 132.567C483.16 133.125 482.706 133.571 482.156 133.571C481.607 133.571 481.153 133.116 481.153 132.567C481.153 132.018 481.607 131.563 482.156 131.563C482.706 131.563 483.16 132.018 483.16 132.567Z",
    fill: "url(#paint101_linear_2809_24943)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M487.192 136.588C487.192 137.146 486.737 137.592 486.188 137.592C485.639 137.592 485.184 137.146 485.184 136.588C485.184 136.03 485.639 135.584 486.188 135.584C486.737 135.584 487.192 136.039 487.192 136.588Z",
    fill: "url(#paint102_linear_2809_24943)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M174.031 132.567C174.031 133.125 173.576 133.571 173.027 133.571C172.478 133.571 172.023 133.116 172.023 132.567C172.023 132.018 172.478 131.563 173.027 131.563C173.576 131.563 174.031 132.018 174.031 132.567Z",
    fill: "url(#paint103_linear_2809_24943)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M178.066 136.588C178.066 137.146 177.611 137.592 177.062 137.592C176.513 137.592 176.058 137.146 176.058 136.588C176.058 136.03 176.513 135.584 177.062 135.584C177.611 135.584 178.066 136.039 178.066 136.588Z",
    fill: "url(#paint104_linear_2809_24943)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M179.412 132.567C179.412 133.125 178.957 133.571 178.408 133.571C177.859 133.571 177.404 133.116 177.404 132.567C177.404 132.018 177.859 131.563 178.408 131.563C178.957 131.563 179.412 132.018 179.412 132.567Z",
    fill: "url(#paint105_linear_2809_24943)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M183.436 136.588C183.436 137.146 182.982 137.592 182.433 137.592C181.883 137.592 181.429 137.146 181.429 136.588C181.429 136.03 181.883 135.584 182.433 135.584C182.982 135.584 183.436 136.039 183.436 136.588Z",
    fill: "url(#paint106_linear_2809_24943)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M186.128 132.567C186.128 133.125 185.673 133.571 185.124 133.571C184.575 133.571 184.12 133.116 184.12 132.567C184.12 132.018 184.575 131.563 185.124 131.563C185.673 131.563 186.128 132.018 186.128 132.567Z",
    fill: "url(#paint107_linear_2809_24943)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M190.163 136.588C190.163 137.146 189.708 137.592 189.159 137.592C188.61 137.592 188.155 137.146 188.155 136.588C188.155 136.03 188.61 135.584 189.159 135.584C189.708 135.584 190.163 136.039 190.163 136.588Z",
    fill: "url(#paint108_linear_2809_24943)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M194.195 132.567C194.195 133.125 193.74 133.571 193.191 133.571C192.642 133.571 192.187 133.116 192.187 132.567C192.187 132.018 192.642 131.563 193.191 131.563C193.74 131.563 194.195 132.018 194.195 132.567Z",
    fill: "url(#paint109_linear_2809_24943)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M198.229 136.588C198.229 137.146 197.774 137.592 197.225 137.592C196.675 137.592 196.221 137.146 196.221 136.588C196.221 136.03 196.675 135.584 197.225 135.584C197.774 135.584 198.229 136.039 198.229 136.588Z",
    fill: "url(#paint110_linear_2809_24943)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M200.914 132.567C200.914 133.125 200.459 133.571 199.91 133.571C199.361 133.571 198.906 133.116 198.906 132.567C198.906 132.018 199.361 131.563 199.91 131.563C200.459 131.563 200.914 132.018 200.914 132.567Z",
    fill: "url(#paint111_linear_2809_24943)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M204.946 136.588C204.946 137.146 204.492 137.592 203.942 137.592C203.393 137.592 202.939 137.146 202.939 136.588C202.939 136.03 203.393 135.584 203.942 135.584C204.492 135.584 204.946 136.039 204.946 136.588Z",
    fill: "url(#paint112_linear_2809_24943)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M206.285 132.567C206.285 133.125 205.83 133.571 205.281 133.571C204.732 133.571 204.277 133.116 204.277 132.567C204.277 132.018 204.732 131.563 205.281 131.563C205.83 131.563 206.285 132.018 206.285 132.567Z",
    fill: "url(#paint113_linear_2809_24943)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M210.317 136.588C210.317 137.146 209.863 137.592 209.314 137.592C208.764 137.592 208.31 137.146 208.31 136.588C208.31 136.03 208.764 135.584 209.314 135.584C209.863 135.584 210.317 136.039 210.317 136.588Z",
    fill: "url(#paint114_linear_2809_24943)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M213.011 132.567C213.011 133.125 212.556 133.571 212.007 133.571C211.458 133.571 211.003 133.116 211.003 132.567C211.003 132.018 211.458 131.563 212.007 131.563C212.556 131.563 213.011 132.018 213.011 132.567Z",
    fill: "url(#paint115_linear_2809_24943)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M217.036 136.588C217.036 137.146 216.581 137.592 216.032 137.592C215.483 137.592 215.028 137.146 215.028 136.588C215.028 136.03 215.483 135.584 216.032 135.584C216.581 135.584 217.036 136.039 217.036 136.588Z",
    fill: "url(#paint116_linear_2809_24943)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M221.068 132.567C221.068 133.125 220.613 133.571 220.064 133.571C219.515 133.571 219.06 133.116 219.06 132.567C219.06 132.018 219.515 131.563 220.064 131.563C220.613 131.563 221.068 132.018 221.068 132.567Z",
    fill: "url(#paint117_linear_2809_24943)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M225.102 136.588C225.102 137.146 224.647 137.592 224.098 137.592C223.549 137.592 223.094 137.146 223.094 136.588C223.094 136.03 223.549 135.584 224.098 135.584C224.647 135.584 225.102 136.039 225.102 136.588Z",
    fill: "url(#paint118_linear_2809_24943)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M227.795 132.567C227.795 133.125 227.34 133.571 226.791 133.571C226.242 133.571 225.787 133.116 225.787 132.567C225.787 132.018 226.242 131.563 226.791 131.563C227.34 131.563 227.795 132.018 227.795 132.567Z",
    fill: "url(#paint119_linear_2809_24943)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M231.829 136.588C231.829 137.146 231.374 137.592 230.825 137.592C230.276 137.592 229.821 137.146 229.821 136.588C229.821 136.03 230.276 135.584 230.825 135.584C231.374 135.584 231.829 136.039 231.829 136.588Z",
    fill: "url(#paint120_linear_2809_24943)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M233.166 132.567C233.166 133.125 232.711 133.571 232.162 133.571C231.613 133.571 231.158 133.116 231.158 132.567C231.158 132.018 231.613 131.563 232.162 131.563C232.711 131.563 233.166 132.018 233.166 132.567Z",
    fill: "url(#paint121_linear_2809_24943)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M237.2 136.588C237.2 137.146 236.745 137.592 236.196 137.592C235.647 137.592 235.192 137.146 235.192 136.588C235.192 136.03 235.647 135.584 236.196 135.584C236.745 135.584 237.2 136.039 237.2 136.588Z",
    fill: "url(#paint122_linear_2809_24943)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M239.885 132.567C239.885 133.125 239.43 133.571 238.881 133.571C238.332 133.571 237.877 133.116 237.877 132.567C237.877 132.018 238.332 131.563 238.881 131.563C239.43 131.563 239.885 132.018 239.885 132.567Z",
    fill: "url(#paint123_linear_2809_24943)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M243.92 136.588C243.92 137.146 243.465 137.592 242.916 137.592C242.367 137.592 241.912 137.146 241.912 136.588C241.912 136.03 242.367 135.584 242.916 135.584C243.465 135.584 243.92 136.039 243.92 136.588Z",
    fill: "url(#paint124_linear_2809_24943)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M247.949 132.567C247.949 133.125 247.494 133.571 246.945 133.571C246.396 133.571 245.941 133.116 245.941 132.567C245.941 132.018 246.396 131.563 246.945 131.563C247.494 131.563 247.949 132.018 247.949 132.567Z",
    fill: "url(#paint125_linear_2809_24943)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M251.982 136.588C251.982 137.146 251.528 137.592 250.978 137.592C250.429 137.592 249.975 137.146 249.975 136.588C249.975 136.03 250.429 135.584 250.978 135.584C251.528 135.584 251.982 136.039 251.982 136.588Z",
    fill: "url(#paint126_linear_2809_24943)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M254.668 132.567C254.668 133.125 254.213 133.571 253.664 133.571C253.115 133.571 252.66 133.116 252.66 132.567C252.66 132.018 253.115 131.563 253.664 131.563C254.213 131.563 254.668 132.018 254.668 132.567Z",
    fill: "url(#paint127_linear_2809_24943)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M258.703 136.588C258.703 137.146 258.248 137.592 257.699 137.592C257.15 137.592 256.695 137.146 256.695 136.588C256.695 136.03 257.15 135.584 257.699 135.584C258.248 135.584 258.703 136.039 258.703 136.588Z",
    fill: "url(#paint128_linear_2809_24943)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M260.047 132.567C260.047 133.125 259.592 133.571 259.043 133.571C258.494 133.571 258.039 133.116 258.039 132.567C258.039 132.018 258.494 131.563 259.043 131.563C259.592 131.563 260.047 132.018 260.047 132.567Z",
    fill: "url(#paint129_linear_2809_24943)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M264.08 136.588C264.08 137.146 263.626 137.592 263.076 137.592C262.527 137.592 262.073 137.146 262.073 136.588C262.073 136.03 262.527 135.584 263.076 135.584C263.626 135.584 264.08 136.039 264.08 136.588Z",
    fill: "url(#paint130_linear_2809_24943)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M266.765 132.567C266.765 133.125 266.31 133.571 265.761 133.571C265.212 133.571 264.757 133.116 264.757 132.567C264.757 132.018 265.212 131.563 265.761 131.563C266.31 131.563 266.765 132.018 266.765 132.567Z",
    fill: "url(#paint131_linear_2809_24943)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M270.8 136.588C270.8 137.146 270.345 137.592 269.796 137.592C269.247 137.592 268.792 137.146 268.792 136.588C268.792 136.03 269.247 135.584 269.796 135.584C270.345 135.584 270.8 136.039 270.8 136.588Z",
    fill: "url(#paint132_linear_2809_24943)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M274.835 132.567C274.835 133.125 274.38 133.571 273.831 133.571C273.282 133.571 272.827 133.116 272.827 132.567C272.827 132.018 273.282 131.563 273.831 131.563C274.38 131.563 274.835 132.018 274.835 132.567Z",
    fill: "url(#paint133_linear_2809_24943)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M278.864 136.588C278.864 137.146 278.41 137.592 277.861 137.592C277.311 137.592 276.857 137.146 276.857 136.588C276.857 136.03 277.311 135.584 277.861 135.584C278.41 135.584 278.864 136.039 278.864 136.588Z",
    fill: "url(#paint134_linear_2809_24943)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M512.73 132.567C512.73 133.125 512.275 133.571 511.726 133.571C511.177 133.571 510.722 133.116 510.722 132.567C510.722 132.018 511.177 131.563 511.726 131.563C512.275 131.563 512.73 132.018 512.73 132.567Z",
    fill: "url(#paint135_linear_2809_24943)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M516.758 136.588C516.758 137.146 516.303 137.592 515.754 137.592C515.205 137.592 514.75 137.146 514.75 136.588C514.75 136.03 515.205 135.584 515.754 135.584C516.303 135.584 516.758 136.039 516.758 136.588Z",
    fill: "url(#paint136_linear_2809_24943)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M518.101 132.567C518.101 133.125 517.646 133.571 517.097 133.571C516.548 133.571 516.093 133.116 516.093 132.567C516.093 132.018 516.548 131.563 517.097 131.563C517.646 131.563 518.101 132.018 518.101 132.567Z",
    fill: "url(#paint137_linear_2809_24943)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M522.135 136.588C522.135 137.146 521.681 137.592 521.131 137.592C520.582 137.592 520.127 137.146 520.127 136.588C520.127 136.03 520.582 135.584 521.131 135.584C521.681 135.584 522.135 136.039 522.135 136.588Z",
    fill: "url(#paint138_linear_2809_24943)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M524.828 132.567C524.828 133.125 524.373 133.571 523.824 133.571C523.275 133.571 522.82 133.116 522.82 132.567C522.82 132.018 523.275 131.563 523.824 131.563C524.373 131.563 524.828 132.018 524.828 132.567Z",
    fill: "url(#paint139_linear_2809_24943)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M528.849 136.588C528.849 137.146 528.394 137.592 527.845 137.592C527.296 137.592 526.841 137.146 526.841 136.588C526.841 136.03 527.296 135.584 527.845 135.584C528.394 135.584 528.849 136.039 528.849 136.588Z",
    fill: "url(#paint140_linear_2809_24943)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M532.883 132.567C532.883 133.125 532.429 133.571 531.88 133.571C531.33 133.571 530.876 133.116 530.876 132.567C530.876 132.018 531.33 131.563 531.88 131.563C532.429 131.563 532.883 132.018 532.883 132.567Z",
    fill: "url(#paint141_linear_2809_24943)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M536.918 136.588C536.918 137.146 536.464 137.592 535.915 137.592C535.365 137.592 534.911 137.146 534.911 136.588C534.911 136.03 535.365 135.584 535.915 135.584C536.464 135.584 536.918 136.039 536.918 136.588Z",
    fill: "url(#paint142_linear_2809_24943)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M539.61 132.567C539.61 133.125 539.156 133.571 538.606 133.571C538.057 133.571 537.603 133.116 537.603 132.567C537.603 132.018 538.057 131.563 538.606 131.563C539.156 131.563 539.61 132.018 539.61 132.567Z",
    fill: "url(#paint143_linear_2809_24943)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M543.645 136.588C543.645 137.146 543.19 137.592 542.641 137.592C542.092 137.592 541.637 137.146 541.637 136.588C541.637 136.03 542.092 135.584 542.641 135.584C543.19 135.584 543.645 136.039 543.645 136.588Z",
    fill: "url(#paint144_linear_2809_24943)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M544.981 132.567C544.981 133.125 544.526 133.571 543.977 133.571C543.428 133.571 542.973 133.116 542.973 132.567C542.973 132.018 543.428 131.563 543.977 131.563C544.526 131.563 544.981 132.018 544.981 132.567Z",
    fill: "url(#paint145_linear_2809_24943)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M549.016 136.588C549.016 137.146 548.561 137.592 548.012 137.592C547.463 137.592 547.008 137.146 547.008 136.588C547.008 136.03 547.463 135.584 548.012 135.584C548.561 135.584 549.016 136.039 549.016 136.588Z",
    fill: "url(#paint146_linear_2809_24943)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M551.701 132.567C551.701 133.125 551.246 133.571 550.697 133.571C550.148 133.571 549.693 133.116 549.693 132.567C549.693 132.018 550.148 131.563 550.697 131.563C551.246 131.563 551.701 132.018 551.701 132.567Z",
    fill: "url(#paint147_linear_2809_24943)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M555.736 136.588C555.736 137.146 555.281 137.592 554.732 137.592C554.183 137.592 553.728 137.146 553.728 136.588C553.728 136.03 554.183 135.584 554.732 135.584C555.281 135.584 555.736 136.039 555.736 136.588Z",
    fill: "url(#paint148_linear_2809_24943)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M559.764 132.567C559.764 133.125 559.309 133.571 558.76 133.571C558.211 133.571 557.756 133.116 557.756 132.567C557.756 132.018 558.211 131.563 558.76 131.563C559.309 131.563 559.764 132.018 559.764 132.567Z",
    fill: "url(#paint149_linear_2809_24943)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M563.799 136.588C563.799 137.146 563.344 137.592 562.795 137.592C562.246 137.592 561.791 137.146 561.791 136.588C561.791 136.03 562.246 135.584 562.795 135.584C563.344 135.584 563.799 136.039 563.799 136.588Z",
    fill: "url(#paint150_linear_2809_24943)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M566.484 132.567C566.484 133.125 566.029 133.571 565.48 133.571C564.931 133.571 564.476 133.116 564.476 132.567C564.476 132.018 564.931 131.563 565.48 131.563C566.029 131.563 566.484 132.018 566.484 132.567Z",
    fill: "url(#paint151_linear_2809_24943)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M570.519 136.588C570.519 137.146 570.064 137.592 569.515 137.592C568.966 137.592 568.511 137.146 568.511 136.588C568.511 136.03 568.966 135.584 569.515 135.584C570.064 135.584 570.519 136.039 570.519 136.588Z",
    fill: "url(#paint152_linear_2809_24943)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M571.861 132.567C571.861 133.125 571.407 133.571 570.857 133.571C570.308 133.571 569.854 133.116 569.854 132.567C569.854 132.018 570.308 131.563 570.857 131.563C571.407 131.563 571.861 132.018 571.861 132.567Z",
    fill: "url(#paint153_linear_2809_24943)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M575.896 136.588C575.896 137.146 575.441 137.592 574.892 137.592C574.343 137.592 573.888 137.146 573.888 136.588C573.888 136.03 574.343 135.584 574.892 135.584C575.441 135.584 575.896 136.039 575.896 136.588Z",
    fill: "url(#paint154_linear_2809_24943)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M578.581 132.567C578.581 133.125 578.127 133.571 577.578 133.571C577.028 133.571 576.574 133.116 576.574 132.567C576.574 132.018 577.028 131.563 577.578 131.563C578.127 131.563 578.581 132.018 578.581 132.567Z",
    fill: "url(#paint155_linear_2809_24943)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M582.616 136.588C582.616 137.146 582.161 137.592 581.612 137.592C581.063 137.592 580.608 137.146 580.608 136.588C580.608 136.03 581.063 135.584 581.612 135.584C582.161 135.584 582.616 136.039 582.616 136.588Z",
    fill: "url(#paint156_linear_2809_24943)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M586.648 132.567C586.648 133.125 586.193 133.571 585.644 133.571C585.095 133.571 584.64 133.116 584.64 132.567C584.64 132.018 585.095 131.563 585.644 131.563C586.193 131.563 586.648 132.018 586.648 132.567Z",
    fill: "url(#paint157_linear_2809_24943)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M590.679 136.588C590.679 137.146 590.224 137.592 589.675 137.592C589.126 137.592 588.671 137.146 588.671 136.588C588.671 136.03 589.126 135.584 589.675 135.584C590.224 135.584 590.679 136.039 590.679 136.588Z",
    fill: "url(#paint158_linear_2809_24943)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M593.364 132.567C593.364 133.125 592.909 133.571 592.36 133.571C591.811 133.571 591.356 133.116 591.356 132.567C591.356 132.018 591.811 131.563 592.36 131.563C592.909 131.563 593.364 132.018 593.364 132.567Z",
    fill: "url(#paint159_linear_2809_24943)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M597.399 136.588C597.399 137.146 596.945 137.592 596.395 137.592C595.846 137.592 595.392 137.146 595.392 136.588C595.392 136.03 595.846 135.584 596.395 135.584C596.945 135.584 597.399 136.039 597.399 136.588Z",
    fill: "url(#paint160_linear_2809_24943)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M598.749 132.567C598.749 133.125 598.294 133.571 597.745 133.571C597.196 133.571 596.741 133.116 596.741 132.567C596.741 132.018 597.196 131.563 597.745 131.563C598.294 131.563 598.749 132.018 598.749 132.567Z",
    fill: "url(#paint161_linear_2809_24943)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M602.776 136.588C602.776 137.146 602.321 137.592 601.772 137.592C601.223 137.592 600.768 137.146 600.768 136.588C600.768 136.03 601.223 135.584 601.772 135.584C602.321 135.584 602.776 136.039 602.776 136.588Z",
    fill: "url(#paint162_linear_2809_24943)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M605.462 132.567C605.462 133.125 605.007 133.571 604.458 133.571C603.909 133.571 603.454 133.116 603.454 132.567C603.454 132.018 603.909 131.563 604.458 131.563C605.007 131.563 605.462 132.018 605.462 132.567Z",
    fill: "url(#paint163_linear_2809_24943)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M609.497 136.588C609.497 137.146 609.042 137.592 608.493 137.592C607.944 137.592 607.489 137.146 607.489 136.588C607.489 136.03 607.944 135.584 608.493 135.584C609.042 135.584 609.497 136.039 609.497 136.588Z",
    fill: "url(#paint164_linear_2809_24943)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M613.532 132.567C613.532 133.125 613.077 133.571 612.528 133.571C611.979 133.571 611.524 133.116 611.524 132.567C611.524 132.018 611.979 131.563 612.528 131.563C613.077 131.563 613.532 132.018 613.532 132.567Z",
    fill: "url(#paint165_linear_2809_24943)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M617.561 136.588C617.561 137.146 617.106 137.592 616.557 137.592C616.008 137.592 615.553 137.146 615.553 136.588C615.553 136.03 616.008 135.584 616.557 135.584C617.106 135.584 617.561 136.039 617.561 136.588Z",
    fill: "url(#paint166_linear_2809_24943)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M620.245 132.567C620.245 133.125 619.79 133.571 619.241 133.571C618.692 133.571 618.237 133.116 618.237 132.567C618.237 132.018 618.692 131.563 619.241 131.563C619.79 131.563 620.245 132.018 620.245 132.567Z",
    fill: "url(#paint167_linear_2809_24943)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M624.279 136.588C624.279 137.146 623.825 137.592 623.275 137.592C622.726 137.592 622.271 137.146 622.271 136.588C622.271 136.03 622.726 135.584 623.275 135.584C623.825 135.584 624.279 136.039 624.279 136.588Z",
    fill: "url(#paint168_linear_2809_24943)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M625.629 132.567C625.629 133.125 625.174 133.571 624.625 133.571C624.076 133.571 623.621 133.116 623.621 132.567C623.621 132.018 624.076 131.563 624.625 131.563C625.174 131.563 625.629 132.018 625.629 132.567Z",
    fill: "url(#paint169_linear_2809_24943)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M629.66 136.588C629.66 137.146 629.206 137.592 628.656 137.592C628.107 137.592 627.653 137.146 627.653 136.588C627.653 136.03 628.107 135.584 628.656 135.584C629.206 135.584 629.66 136.039 629.66 136.588Z",
    fill: "url(#paint170_linear_2809_24943)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M632.349 132.567C632.349 133.125 631.894 133.571 631.345 133.571C630.796 133.571 630.341 133.116 630.341 132.567C630.341 132.018 630.796 131.563 631.345 131.563C631.894 131.563 632.349 132.018 632.349 132.567Z",
    fill: "url(#paint171_linear_2809_24943)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M636.377 136.588C636.377 137.146 635.922 137.592 635.373 137.592C634.824 137.592 634.369 137.146 634.369 136.588C634.369 136.03 634.824 135.584 635.373 135.584C635.922 135.584 636.377 136.039 636.377 136.588Z",
    fill: "url(#paint172_linear_2809_24943)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M805.727 142.313L806.414 127.529H141.856C138.844 127.529 136.399 129.975 136.399 132.986V186.536L153.868 142.313H805.719H805.727Z",
    fill: "#B2AFA3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M867.106 201.135H800V142H866.317",
    fill: "url(#paint173_linear_2809_24943)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M865.083 144.035C868.052 137.943 871.99 134.254 876.289 134.254C885.564 134.254 893.089 151.406 893.089 172.556C893.089 193.707 885.564 210.858 876.289 210.858C872.333 210.858 868.129 201.961 865.272 196.744",
    fill: "url(#paint174_linear_2809_24943)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M865.083 144.035C868.052 137.943 871.99 134.254 876.289 134.254C885.564 134.254 893.089 151.406 893.089 172.556C893.089 193.707 885.564 210.858 876.289 210.858C872.333 210.858 868.129 201.961 865.272 196.744",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M884.629 193.401H837.317C836.202 193.401 835.318 192.5 835.318 191.402V155.099C835.318 153.983 836.219 153.1 837.317 153.1H884.938",
    fill: "url(#paint175_linear_2809_24943)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M884.629 193.401H837.317C836.202 193.401 835.318 192.5 835.318 191.402V155.099C835.318 153.983 836.219 153.1 837.317 153.1H884.938",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M843.239 154.675V191.853C843.239 192.78 843.994 193.518 844.904 193.518H854.402C855.329 193.518 856.067 192.763 856.067 191.853V188.704C856.067 188.258 856.238 187.829 856.547 187.52L859.293 184.774C859.602 184.466 859.773 184.037 859.773 183.59V164.508C859.773 164.062 859.602 163.633 859.293 163.324L856.753 160.784C856.444 160.475 856.273 160.046 856.273 159.6V154.563C856.273 153.637 855.518 152.882 854.591 152.899L844.87 152.993C843.951 152.993 843.214 153.748 843.214 154.658L843.231 154.675H843.239Z",
    fill: "url(#paint176_radial_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M859.791 163.798H887.703H859.791Z",
    fill: "url(#paint177_linear_2809_24943)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M859.791 163.798H887.703",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M859.791 183.966H887.703H859.791Z",
    fill: "url(#paint178_linear_2809_24943)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M859.791 183.966H887.703",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M798.349 153.663H188.816L178.374 164.105H163.281H159.249L157.593 167.778L154.315 175.037L142.852 200.4L141.213 204.029L119.573 251.89C117.394 256.712 116.416 262.015 116.708 267.291L117.583 282.479C117.583 289.686 123.417 295.512 130.616 295.512H165.967L171.424 300.969C173.517 303.063 176.366 304.247 179.343 304.247H210.378L203.385 276.987H178.58C175.688 276.987 172.925 278.128 170.866 280.162L167.949 283.088L166.808 284.229H136.622C130.573 284.229 125.665 279.321 125.665 273.272L126.592 262.572C126.858 259.458 127.656 256.42 128.943 253.563L159.952 184.672L161.634 180.905L163.29 177.224H180.759L189.494 185.959H798.701",
    fill: "#B3D336"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M618.205 259.177H531.733V311.636H618.205V259.177Z",
    fill: "url(#paint179_linear_2809_24943)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M89.44 313.068L81.2973 304.925H28.8805V300.892H0.660034V282.076H28.8805V276.027H79.281L81.2973 274.01H89.5258V264.607L89.8175 264.409",
    fill: "#3385AE"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M126.988 286.112H14.0371V295.516H126.988V286.112Z",
    fill: "#B3D336"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M416.543 300.679V320.68H408.855V328.599H390.897V251.737L408.855 251.806V256.474H416.543V280.344",
    fill: "url(#paint180_linear_2809_24943)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M444.945 279.899V301.281C444.945 302.662 443.813 303.795 442.431 303.795H418.656C417.274 303.795 416.142 302.662 416.142 301.281V297.986C416.142 296.604 415.009 295.472 413.628 295.472H411.491C410.11 295.472 408.977 294.339 408.977 292.958V286.857C408.977 285.476 410.11 284.343 411.491 284.343H413.885C415.266 284.343 416.399 283.211 416.399 281.829V279.478C416.399 278.071 417.557 276.939 418.956 276.964L442.474 277.385C443.847 277.41 444.945 278.526 444.945 279.899Z",
    fill: "url(#paint181_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M449.191 281.457H445.09V299.295H449.191V281.457Z",
    fill: "url(#paint182_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M449.092 255.836H471.563C473.837 255.836 475.673 257.681 475.673 259.946V321.526C475.673 323.8 473.828 325.636 471.563 325.636H449.092V255.827V255.836Z",
    fill: "url(#paint183_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M448.813 306.331H442.052V311.651H448.813V306.331Z",
    fill: "url(#paint184_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M448.813 315.675H442.052V320.995H448.813V315.675Z",
    fill: "url(#paint185_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M449.114 259.175H442.876V265.293H449.114V259.175Z",
    fill: "url(#paint186_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M449.114 268.595H442.876V272.198H449.114V268.595Z",
    fill: "url(#paint187_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.31 98.6162H921.313V146.829C921.313 163.268 917.254 179.451 909.489 193.934L871.59 264.601H1130.32V98.6162H1130.31Z",
    fill: "#56A3D2"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.93 220.103L993.895 210.184L950.883 177.253L972.917 132.85C976.795 126.432 983.668 122.416 991.158 122.193L1040.93 122.82V220.103Z",
    fill: "url(#paint188_radial_2809_24943)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M950.881 177.234L975.275 129.605C977.626 125.023 982.345 122.132 987.493 122.132H1098.75C1109.1 122.132 1115.73 133.14 1110.89 142.295L1064.95 229.068C1062.57 233.555 1057.89 236.378 1052.81 236.378H941.743C931.31 236.378 924.703 225.224 929.688 216.069L950.873 177.243H950.89L950.881 177.234Z",
    fill: "#9EACAC"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M967.254 170.03L967.013 197.796L975.765 207.492L1040.93 208.152V228.307H971.14H948.729V181.468L954.34 170.047L967.254 170.03Z",
    fill: "url(#paint189_radial_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M981.126 196.066C984.464 196.066 987.175 186.139 987.175 173.886C987.175 161.633 984.464 151.706 981.126 151.706C977.789 151.706 975.077 161.633 975.077 173.886C975.077 186.139 977.789 196.066 981.126 196.066Z",
    fill: "url(#paint190_linear_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M981.178 143.557H968.179L954.339 170.061L967.252 170.044L981.178 143.557Z",
    fill: "url(#paint191_radial_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M954.872 228.303H948.729V181.463L954.332 170.043H967.245",
    fill: "url(#paint192_linear_2809_24943)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M954.872 228.303H948.729V181.463L954.332 170.043H967.245",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.55 228.312H971.135",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.61 208.173L990.522 198.083C990.102 197.662 989.862 197.087 989.862 196.487V145.915C989.862 144.662 988.858 143.658 987.605 143.658H981.856C980.998 143.658 980.217 144.139 979.84 144.911L967.261 170.068C967.098 170.377 967.021 170.729 967.021 171.072V197.834C967.021 198.435 967.261 199.001 967.682 199.43L975.773 207.521C976.193 207.942 976.768 208.182 977.369 208.182H1040.94V228.345H1024.77",
    fill: "url(#paint193_radial_2809_24943)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.61 208.173L990.522 198.083C990.102 197.662 989.862 197.087 989.862 196.487V145.915C989.862 144.662 988.858 143.658 987.605 143.658H981.856C980.998 143.658 980.217 144.139 979.84 144.911L967.261 170.068C967.098 170.377 967.021 170.729 967.021 171.072V197.834C967.021 198.435 967.261 199.001 967.682 199.43L975.773 207.521C976.193 207.942 976.768 208.182 977.369 208.182H1040.94V228.345H1024.77",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M976.341 162.906H981.317C982.321 162.906 983.145 163.73 983.145 164.734V182.152C983.145 183.156 982.321 183.979 981.317 183.979H976.074",
    fill: "url(#paint194_linear_2809_24943)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M976.341 162.906H981.317C982.321 162.906 983.145 163.73 983.145 164.734V182.152C983.145 183.156 982.321 183.979 981.317 183.979H976.074",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M993.895 201.146V170.515H999.275V206.277",
    fill: "url(#paint195_linear_2809_24943)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M993.895 201.146V170.515H999.275V206.277",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M971.041 222.956H954.91V231.021H971.041V222.956Z",
    fill: "url(#paint196_radial_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M958.278 228.322C958.647 228.322 958.948 228.022 958.948 227.653C958.948 227.284 958.647 226.983 958.278 226.983C957.909 226.983 957.609 227.284 957.609 227.653C957.609 228.022 957.909 228.322 958.278 228.322Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M967.684 228.322C968.053 228.322 968.353 228.022 968.353 227.653C968.353 227.284 968.053 226.983 967.684 226.983C967.315 226.983 967.015 227.284 967.015 227.653C967.015 228.022 967.315 228.322 967.684 228.322Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1024.8 222.956H1008.67V231.021H1024.8V222.956Z",
    fill: "url(#paint197_radial_2809_24943)",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.03 228.322C1012.4 228.322 1012.7 228.022 1012.7 227.653C1012.7 227.284 1012.4 226.983 1012.03 226.983C1011.66 226.983 1011.36 227.284 1011.36 227.653C1011.36 228.022 1011.66 228.322 1012.03 228.322Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.44 228.322C1021.81 228.322 1022.11 228.022 1022.11 227.653C1022.11 227.284 1021.81 226.983 1021.44 226.983C1021.08 226.983 1020.78 227.284 1020.78 227.653C1020.78 228.022 1021.08 228.322 1021.44 228.322Z",
    stroke: "#333333",
    strokeWidth: 1.17,
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.94 122.811H1032.33V207.378H1040.94V122.811Z",
    fill: "url(#paint198_linear_2809_24943)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M330.716 277.388H199.73C198.666 277.388 197.636 277.697 196.778 278.263L183.556 286.989C180.699 288.868 180.716 292.781 183.582 294.651L196.058 302.76C196.916 303.309 197.937 303.618 198.983 303.618H330.364",
    fill: "url(#paint199_linear_2809_24943)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M330.716 280.56H208.585C207.589 280.56 206.628 280.791 205.83 281.203L193.5 287.638C190.841 289.028 190.849 291.911 193.526 293.293L205.161 299.273C205.959 299.676 206.911 299.908 207.89 299.908H330.39",
    stroke: "url(#paint200_linear_2809_24943)",
    strokeWidth: 1.83,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M844.031 0.49707H796.316V38.7993H844.031V0.49707Z",
    fill: "#3385AE"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M796.316 57.8499V43.967C796.316 43.3492 796.814 42.8516 797.431 42.8516H842.229C842.847 42.8516 843.344 43.3492 843.344 43.967V57.97C843.344 58.5449 842.915 59.0168 842.349 59.0854L837.81 59.6002C837.484 59.6431 837.209 59.8062 837.021 60.0722L829.59 70.6087C829.376 70.9004 829.041 71.0806 828.672 71.0806H813.056C812.678 71.0806 812.327 70.8919 812.129 70.583L804.733 59.4801C804.536 59.1712 804.167 58.9825 803.806 58.9825H797.466C796.848 58.9825 796.35 58.4848 796.35 57.867L796.325 57.8499H796.316Z",
    fill: "#3385AE"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M850.081 38.8184H788.252V42.8511H850.081V38.8184Z",
    fill: "#3385AE"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M858.146 84.4987H794.978V75.0947H858.146V84.4987Z",
    fill: "#9EACAC"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M798.521 84.4909L802.794 88.7811H850.08L854.422 84.4395",
    fill: "#9EACAC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M802.794 83.583V99.2849H840.668V93.9051H858.137V84.5011L802.786 83.583H802.794Z",
    fill: "#9EACAC"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M843.362 99.2832H799.01V116.753H843.362V99.2832Z",
    fill: "#9EACAC"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M800.349 75.0996V67.9094C800.349 67.4289 800.735 67.0342 801.224 67.0342H804.854C805.334 67.0342 805.729 67.4203 805.729 67.9094V70.1917C805.729 70.6722 806.115 71.0669 806.604 71.0669H835.768C836.249 71.0669 836.644 70.6808 836.644 70.1917V67.9094C836.644 67.4289 837.03 67.0342 837.519 67.0342H841.148C841.629 67.0342 842.024 67.4203 842.024 67.9094V75.3828",
    fill: "#9EACAC"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M837.981 3.84473V52.2288L828.577 61.6414V138.486H814.128V62.9799L803.883 51.3965L804.381 3.84473H837.981Z",
    fill: "#56A3D2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M795.596 81.5566H852.775V84.4997",
    fill: "#9EACAC"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M298.351 158.562H317.211H799.009V183.059H298.351V158.562Z",
    fill: "url(#paint201_linear_2809_24943)",
    stroke: "url(#paint202_linear_2809_24943)",
    strokeWidth: 1.12,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M311.155 183.656L307.903 158.876",
    stroke: "url(#paint203_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M323.046 183.656L319.795 158.876",
    stroke: "url(#paint204_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M334.946 183.656L331.686 158.876",
    stroke: "url(#paint205_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M346.839 183.656L343.587 158.876",
    stroke: "url(#paint206_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M358.734 183.656L355.482 158.876",
    stroke: "url(#paint207_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M370.634 183.656L367.374 158.876",
    stroke: "url(#paint208_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M382.523 183.656L379.271 158.876",
    stroke: "url(#paint209_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M394.414 183.656L391.163 158.876",
    stroke: "url(#paint210_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M406.315 183.656L403.054 158.876",
    stroke: "url(#paint211_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M418.211 183.656L414.959 158.876",
    stroke: "url(#paint212_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M430.102 183.656L426.851 158.876",
    stroke: "url(#paint213_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M441.994 183.656L438.742 158.876",
    stroke: "url(#paint214_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M453.895 183.656L450.643 158.876",
    stroke: "url(#paint215_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M465.789 183.656L462.537 158.876",
    stroke: "url(#paint216_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M477.681 183.656L474.429 158.876",
    stroke: "url(#paint217_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M489.579 183.656L486.327 158.876",
    stroke: "url(#paint218_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M501.471 183.656L498.219 158.876",
    stroke: "url(#paint219_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M513.362 183.656L510.11 158.876",
    stroke: "url(#paint220_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M525.267 183.656L522.015 158.876",
    stroke: "url(#paint221_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M537.159 183.656L533.907 158.876",
    stroke: "url(#paint222_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M549.05 183.656L545.798 158.876",
    stroke: "url(#paint223_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M560.95 183.656L557.689 158.876",
    stroke: "url(#paint224_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M572.844 183.656L569.592 158.876",
    stroke: "url(#paint225_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M584.736 183.656L581.484 158.876",
    stroke: "url(#paint226_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M596.638 183.656L593.377 158.876",
    stroke: "url(#paint227_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M608.527 183.656L605.275 158.876",
    stroke: "url(#paint228_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M620.418 183.656L617.166 158.876",
    stroke: "url(#paint229_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M632.322 183.656L629.061 158.876",
    stroke: "url(#paint230_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M644.213 183.656L640.961 158.876",
    stroke: "url(#paint231_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M656.106 183.656L652.854 158.876",
    stroke: "url(#paint232_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M668.006 183.656L664.746 158.876",
    stroke: "url(#paint233_linear_2809_24943)",
    strokeWidth: 5.51,
    strokeMiterlimit: 10
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M260.83 157.421H227.281C226.303 157.421 225.342 157.73 224.552 158.296L212.351 167.022C209.717 168.901 209.734 172.814 212.377 174.684L223.892 182.793C224.681 183.342 225.625 183.651 226.595 183.651H260.504",
    fill: "url(#paint234_linear_2809_24943)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M295.305 156.402H263.773C260.976 156.402 258.702 158.668 258.702 161.473V179.56C258.702 182.358 260.967 184.631 263.773 184.631H295.305C298.103 184.631 300.376 182.366 300.376 179.56V161.473C300.376 158.676 298.111 156.402 295.305 156.402Z",
    fill: "url(#paint235_linear_2809_24943)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M263.794 156.402L300.38 178.582L263.794 156.402Z",
    fill: "url(#paint236_linear_2809_24943)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M263.794 156.402L300.38 178.582",
    stroke: "url(#paint237_radial_2809_24943)",
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M280.67 156.383L300.491 167.632L280.67 156.383Z",
    fill: "url(#paint238_linear_2809_24943)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M280.67 156.383L300.491 167.632",
    stroke: "url(#paint239_radial_2809_24943)",
    strokeMiterlimit: 10
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M258.762 162.782L294.567 184.525L258.762 162.782Z",
    fill: "url(#paint240_linear_2809_24943)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M258.762 162.782L294.567 184.525",
    stroke: "url(#paint241_radial_2809_24943)",
    strokeMiterlimit: 10
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M258.762 175.272L277.441 184.591L258.762 175.272Z",
    fill: "url(#paint242_linear_2809_24943)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M258.762 175.272L277.441 184.591",
    stroke: "url(#paint243_radial_2809_24943)",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2809_24943",
    x1: 891.035,
    y1: 73.4424,
    x2: 937.498,
    y2: 73.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2809_24943",
    x1: 903.856,
    y1: 34.7823,
    x2: 925.358,
    y2: 34.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2809_24943",
    x1: 910.564,
    y1: 22.6989,
    x2: 917.283,
    y2: 22.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2809_24943",
    x1: 953.537,
    y1: 54.6087,
    x2: 999.999,
    y2: 54.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2809_24943",
    x1: 966.352,
    y1: 34.7823,
    x2: 987.854,
    y2: 34.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2809_24943",
    x1: 973.066,
    y1: 22.6989,
    x2: 979.784,
    y2: 22.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2809_24943",
    x1: 1016.03,
    y1: 54.6087,
    x2: 1062.49,
    y2: 54.6087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2809_24943",
    x1: 1028.85,
    y1: 34.7823,
    x2: 1050.36,
    y2: 34.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2809_24943",
    x1: 1035.56,
    y1: 22.6989,
    x2: 1042.28,
    y2: 22.6989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2809_24943",
    x1: 111.601,
    y1: 290.181,
    x2: 136.398,
    y2: 290.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2809_24943",
    x1: 797.663,
    y1: 192.22,
    x2: 900.034,
    y2: 192.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2809_24943",
    x1: 205.83,
    y1: 509.644,
    x2: 1150.87,
    y2: 509.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2809_24943",
    x1: 327.574,
    y1: 393.12,
    x2: 680.446,
    y2: 393.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2809_24943",
    x1: 495.464,
    y1: 225.229,
    x2: 531.947,
    y2: 225.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2809_24943",
    x1: 495.464,
    y1: 353.708,
    x2: 531.947,
    y2: 353.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2809_24943",
    x1: 531.733,
    y1: 229.883,
    x2: 618.205,
    y2: 229.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2809_24943",
    x1: 531.733,
    y1: 248.341,
    x2: 618.205,
    y2: 248.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2809_24943",
    x1: 531.733,
    y1: 328.806,
    x2: 618.205,
    y2: 328.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2809_24943",
    x1: 618.224,
    y1: 283.69,
    x2: 660.327,
    y2: 283.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EABE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2809_24943",
    x1: 659.776,
    y1: 251.427,
    x2: 678.335,
    y2: 251.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EABE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2809_24943",
    x1: 659.776,
    y1: 326.698,
    x2: 678.335,
    y2: 326.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EABE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2809_24943",
    x1: 338.001,
    y1: 251.091,
    x2: 355.788,
    y2: 251.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2809_24943",
    x1: 207.632,
    y1: 251.179,
    x2: 338,
    y2: 251.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2809_24943",
    x1: 198.236,
    y1: 251.198,
    x2: 207.649,
    y2: 251.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2809_24943",
    x1: 194.204,
    y1: 238.437,
    x2: 198.237,
    y2: 238.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2809_24943",
    x1: 191.519,
    y1: 251.195,
    x2: 198.237,
    y2: 251.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2809_24943",
    x1: 154.169,
    y1: 227.854,
    x2: 152.71,
    y2: 263.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2809_24943",
    x1: 89.3529,
    y1: 251.181,
    x2: 114.896,
    y2: 251.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2809_24943",
    x1: 194.204,
    y1: 265.319,
    x2: 198.237,
    y2: 265.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2809_24943",
    x1: 86.6666,
    y1: 251.2,
    x2: 101.45,
    y2: 251.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2809_24943",
    x1: 77.2719,
    y1: 250.55,
    x2: 87.8685,
    y2: 250.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2809_24943",
    x1: 338.001,
    y1: 327.718,
    x2: 355.788,
    y2: 327.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EEEDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2809_24943",
    x1: 207.632,
    y1: 327.787,
    x2: 338,
    y2: 327.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2809_24943",
    x1: 198.236,
    y1: 327.795,
    x2: 207.649,
    y2: 327.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2809_24943",
    x1: 191.519,
    y1: 327.791,
    x2: 198.237,
    y2: 327.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2809_24943",
    x1: 152.676,
    y1: 313.773,
    x2: 153.749,
    y2: 341.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2809_24943",
    x1: 89.3529,
    y1: 327.787,
    x2: 114.896,
    y2: 327.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2809_24943",
    x1: 194.204,
    y1: 341.925,
    x2: 198.237,
    y2: 341.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2809_24943",
    x1: 86.6666,
    y1: 327.797,
    x2: 101.45,
    y2: 327.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2809_24943",
    x1: 77.2719,
    y1: 327.15,
    x2: 87.8685,
    y2: 327.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2809_24943",
    x1: 865.95,
    y1: 172.575,
    x2: 887.787,
    y2: 172.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2809_24943",
    x1: 805.728,
    y1: 212.208,
    x2: 837.981,
    y2: 212.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2809_24943",
    x1: 837.982,
    y1: 211.577,
    x2: 844.237,
    y2: 211.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2809_24943",
    x1: 853.666,
    y1: 216.524,
    x2: 895.237,
    y2: 216.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2809_24943",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2809_24943",
    x1: 849.412,
    y1: 135.595,
    x2: 870.245,
    y2: 135.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2809_24943",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2809_24943",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2809_24943",
    x1: 784.901,
    y1: 170.035,
    x2: 798.346,
    y2: 170.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2809_24943",
    x1: 141.78,
    y1: 315.705,
    x2: 148.498,
    y2: 315.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2809_24943",
    x1: 141.78,
    y1: 263.294,
    x2: 148.498,
    y2: 263.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2809_24943",
    x1: 326.588,
    y1: 132.567,
    x2: 328.595,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2809_24943",
    x1: 330.623,
    y1: 136.588,
    x2: 332.63,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2809_24943",
    x1: 331.958,
    y1: 132.567,
    x2: 333.966,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2809_24943",
    x1: 335.993,
    y1: 136.588,
    x2: 338.001,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2809_24943",
    x1: 338.685,
    y1: 132.567,
    x2: 340.693,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2809_24943",
    x1: 342.713,
    y1: 136.588,
    x2: 344.721,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2809_24943",
    x1: 298.359,
    y1: 132.567,
    x2: 300.366,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2809_24943",
    x1: 302.393,
    y1: 136.588,
    x2: 304.401,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2809_24943",
    x1: 305.085,
    y1: 132.567,
    x2: 307.093,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2809_24943",
    x1: 309.113,
    y1: 136.588,
    x2: 311.121,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2809_24943",
    x1: 346.743,
    y1: 132.567,
    x2: 348.751,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2809_24943",
    x1: 350.776,
    y1: 136.588,
    x2: 352.784,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2809_24943",
    x1: 353.469,
    y1: 132.567,
    x2: 355.477,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2809_24943",
    x1: 357.503,
    y1: 136.588,
    x2: 359.511,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2809_24943",
    x1: 358.84,
    y1: 132.567,
    x2: 360.848,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2809_24943",
    x1: 362.874,
    y1: 136.588,
    x2: 364.881,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2809_24943",
    x1: 365.559,
    y1: 132.567,
    x2: 367.567,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2809_24943",
    x1: 369.594,
    y1: 136.588,
    x2: 371.602,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2809_24943",
    x1: 373.626,
    y1: 132.567,
    x2: 375.634,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2809_24943",
    x1: 377.656,
    y1: 136.588,
    x2: 379.664,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2809_24943",
    x1: 380.342,
    y1: 132.567,
    x2: 382.35,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2809_24943",
    x1: 384.377,
    y1: 136.588,
    x2: 386.384,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2809_24943",
    x1: 385.726,
    y1: 132.567,
    x2: 387.734,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2809_24943",
    x1: 389.755,
    y1: 136.588,
    x2: 391.763,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2809_24943",
    x1: 392.439,
    y1: 132.567,
    x2: 394.447,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2809_24943",
    x1: 396.474,
    y1: 136.588,
    x2: 398.482,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2809_24943",
    x1: 400.509,
    y1: 132.567,
    x2: 402.517,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2809_24943",
    x1: 404.538,
    y1: 136.588,
    x2: 406.546,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2809_24943",
    x1: 407.229,
    y1: 132.567,
    x2: 409.237,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2809_24943",
    x1: 411.257,
    y1: 136.588,
    x2: 413.264,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2809_24943",
    x1: 412.606,
    y1: 132.567,
    x2: 414.614,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2809_24943",
    x1: 416.641,
    y1: 136.588,
    x2: 418.648,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2809_24943",
    x1: 419.326,
    y1: 132.567,
    x2: 421.334,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2809_24943",
    x1: 423.354,
    y1: 136.588,
    x2: 425.362,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2809_24943",
    x1: 427.389,
    y1: 132.567,
    x2: 429.397,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2809_24943",
    x1: 431.424,
    y1: 136.588,
    x2: 433.432,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2809_24943",
    x1: 434.109,
    y1: 132.567,
    x2: 436.117,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2809_24943",
    x1: 438.139,
    y1: 136.588,
    x2: 440.147,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2809_24943",
    x1: 439.487,
    y1: 132.567,
    x2: 441.494,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2809_24943",
    x1: 443.521,
    y1: 136.588,
    x2: 445.529,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2809_24943",
    x1: 446.207,
    y1: 132.567,
    x2: 448.215,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2809_24943",
    x1: 450.241,
    y1: 136.588,
    x2: 452.249,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2809_24943",
    x1: 454.269,
    y1: 132.567,
    x2: 456.277,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2809_24943",
    x1: 458.304,
    y1: 136.588,
    x2: 460.312,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2809_24943",
    x1: 460.99,
    y1: 132.567,
    x2: 462.997,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2809_24943",
    x1: 465.024,
    y1: 136.588,
    x2: 467.032,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2809_24943",
    x1: 466.367,
    y1: 132.567,
    x2: 468.374,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2809_24943",
    x1: 470.395,
    y1: 136.588,
    x2: 472.403,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2809_24943",
    x1: 473.087,
    y1: 132.567,
    x2: 475.095,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2809_24943",
    x1: 477.122,
    y1: 136.588,
    x2: 479.129,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2809_24943",
    x1: 481.153,
    y1: 132.567,
    x2: 483.16,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2809_24943",
    x1: 485.184,
    y1: 136.588,
    x2: 487.192,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2809_24943",
    x1: 172.023,
    y1: 132.567,
    x2: 174.031,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2809_24943",
    x1: 176.058,
    y1: 136.588,
    x2: 178.066,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2809_24943",
    x1: 177.404,
    y1: 132.567,
    x2: 179.412,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2809_24943",
    x1: 181.429,
    y1: 136.588,
    x2: 183.436,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2809_24943",
    x1: 184.12,
    y1: 132.567,
    x2: 186.128,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2809_24943",
    x1: 188.155,
    y1: 136.588,
    x2: 190.163,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2809_24943",
    x1: 192.187,
    y1: 132.567,
    x2: 194.195,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2809_24943",
    x1: 196.221,
    y1: 136.588,
    x2: 198.229,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2809_24943",
    x1: 198.906,
    y1: 132.567,
    x2: 200.914,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2809_24943",
    x1: 202.939,
    y1: 136.588,
    x2: 204.946,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2809_24943",
    x1: 204.277,
    y1: 132.567,
    x2: 206.285,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2809_24943",
    x1: 208.31,
    y1: 136.588,
    x2: 210.317,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2809_24943",
    x1: 211.003,
    y1: 132.567,
    x2: 213.011,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2809_24943",
    x1: 215.028,
    y1: 136.588,
    x2: 217.036,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2809_24943",
    x1: 219.06,
    y1: 132.567,
    x2: 221.068,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2809_24943",
    x1: 223.094,
    y1: 136.588,
    x2: 225.102,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2809_24943",
    x1: 225.787,
    y1: 132.567,
    x2: 227.795,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2809_24943",
    x1: 229.821,
    y1: 136.588,
    x2: 231.829,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2809_24943",
    x1: 231.158,
    y1: 132.567,
    x2: 233.166,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2809_24943",
    x1: 235.192,
    y1: 136.588,
    x2: 237.2,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2809_24943",
    x1: 237.877,
    y1: 132.567,
    x2: 239.885,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2809_24943",
    x1: 241.912,
    y1: 136.588,
    x2: 243.92,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2809_24943",
    x1: 245.941,
    y1: 132.567,
    x2: 247.949,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2809_24943",
    x1: 249.975,
    y1: 136.588,
    x2: 251.982,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2809_24943",
    x1: 252.66,
    y1: 132.567,
    x2: 254.668,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2809_24943",
    x1: 256.695,
    y1: 136.588,
    x2: 258.703,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2809_24943",
    x1: 258.039,
    y1: 132.567,
    x2: 260.047,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2809_24943",
    x1: 262.073,
    y1: 136.588,
    x2: 264.08,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2809_24943",
    x1: 264.757,
    y1: 132.567,
    x2: 266.765,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2809_24943",
    x1: 268.792,
    y1: 136.588,
    x2: 270.8,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2809_24943",
    x1: 272.827,
    y1: 132.567,
    x2: 274.835,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2809_24943",
    x1: 276.857,
    y1: 136.588,
    x2: 278.864,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2809_24943",
    x1: 510.722,
    y1: 132.567,
    x2: 512.73,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2809_24943",
    x1: 514.75,
    y1: 136.588,
    x2: 516.758,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2809_24943",
    x1: 516.093,
    y1: 132.567,
    x2: 518.101,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2809_24943",
    x1: 520.127,
    y1: 136.588,
    x2: 522.135,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2809_24943",
    x1: 522.82,
    y1: 132.567,
    x2: 524.828,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2809_24943",
    x1: 526.841,
    y1: 136.588,
    x2: 528.849,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2809_24943",
    x1: 530.876,
    y1: 132.567,
    x2: 532.883,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2809_24943",
    x1: 534.911,
    y1: 136.588,
    x2: 536.918,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2809_24943",
    x1: 537.603,
    y1: 132.567,
    x2: 539.61,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2809_24943",
    x1: 541.637,
    y1: 136.588,
    x2: 543.645,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2809_24943",
    x1: 542.973,
    y1: 132.567,
    x2: 544.981,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2809_24943",
    x1: 547.008,
    y1: 136.588,
    x2: 549.016,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2809_24943",
    x1: 549.693,
    y1: 132.567,
    x2: 551.701,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2809_24943",
    x1: 553.728,
    y1: 136.588,
    x2: 555.736,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2809_24943",
    x1: 557.756,
    y1: 132.567,
    x2: 559.764,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2809_24943",
    x1: 561.791,
    y1: 136.588,
    x2: 563.799,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2809_24943",
    x1: 564.476,
    y1: 132.567,
    x2: 566.484,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2809_24943",
    x1: 568.511,
    y1: 136.588,
    x2: 570.519,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2809_24943",
    x1: 569.854,
    y1: 132.567,
    x2: 571.861,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2809_24943",
    x1: 573.888,
    y1: 136.588,
    x2: 575.896,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2809_24943",
    x1: 576.574,
    y1: 132.567,
    x2: 578.581,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2809_24943",
    x1: 580.608,
    y1: 136.588,
    x2: 582.616,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2809_24943",
    x1: 584.64,
    y1: 132.567,
    x2: 586.648,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2809_24943",
    x1: 588.671,
    y1: 136.588,
    x2: 590.679,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2809_24943",
    x1: 591.356,
    y1: 132.567,
    x2: 593.364,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2809_24943",
    x1: 595.392,
    y1: 136.588,
    x2: 597.399,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2809_24943",
    x1: 596.741,
    y1: 132.567,
    x2: 598.749,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2809_24943",
    x1: 600.768,
    y1: 136.588,
    x2: 602.776,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2809_24943",
    x1: 603.454,
    y1: 132.567,
    x2: 605.462,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2809_24943",
    x1: 607.489,
    y1: 136.588,
    x2: 609.497,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2809_24943",
    x1: 611.524,
    y1: 132.567,
    x2: 613.532,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2809_24943",
    x1: 615.553,
    y1: 136.588,
    x2: 617.561,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2809_24943",
    x1: 618.237,
    y1: 132.567,
    x2: 620.245,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2809_24943",
    x1: 622.271,
    y1: 136.588,
    x2: 624.279,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2809_24943",
    x1: 623.621,
    y1: 132.567,
    x2: 625.629,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2809_24943",
    x1: 627.653,
    y1: 136.588,
    x2: 629.66,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2809_24943",
    x1: 630.341,
    y1: 132.567,
    x2: 632.349,
    y2: 132.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2809_24943",
    x1: 634.369,
    y1: 136.588,
    x2: 636.377,
    y2: 136.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2809_24943",
    x1: 800,
    y1: 171.568,
    x2: 867.106,
    y2: 171.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2809_24943",
    x1: 865.083,
    y1: 172.556,
    x2: 893.089,
    y2: 172.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2809_24943",
    x1: 835.309,
    y1: 173.246,
    x2: 884.938,
    y2: 173.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(851.502 173.208) scale(15.5045 15.5045)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2809_24943",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2809_24943",
    x1: "nan",
    y1: "nan",
    x2: "nan",
    y2: "nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2809_24943",
    x1: 576.025,
    y1: 239.734,
    x2: 574.025,
    y2: 326.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2809_24943",
    x1: 390.906,
    y1: 290.168,
    x2: 416.543,
    y2: 290.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2809_24943",
    x1: 416.142,
    y1: 276.183,
    x2: 443.83,
    y2: 303.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2809_24943",
    x1: 422.18,
    y1: 265.412,
    x2: 455,
    y2: 298.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2809_24943",
    x1: 449.092,
    y1: 290.74,
    x2: 475.673,
    y2: 290.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2809_24943",
    x1: 442.061,
    y1: 308.991,
    x2: 448.813,
    y2: 308.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2809_24943",
    x1: 442.061,
    y1: 318.335,
    x2: 448.813,
    y2: 318.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2809_24943",
    x1: 442.876,
    y1: 262.238,
    x2: 449.114,
    y2: 262.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2809_24943",
    x1: 442.876,
    y1: 270.397,
    x2: 449.114,
    y2: 270.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(991.697 171.144) scale(299.019 34.8101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(994.83 199.169) scale(38.5597 38.5597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2809_24943",
    x1: 975.077,
    y1: 173.886,
    x2: 987.167,
    y2: 173.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(967.758 156.805) scale(13.3337 13.3337)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2809_24943",
    x1: 948.729,
    y1: 199.173,
    x2: 967.253,
    y2: 199.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1003.97 185.985) scale(39.7438 39.7438)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2809_24943",
    x1: 976.074,
    y1: 173.451,
    x2: 983.136,
    y2: 173.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2809_24943",
    x1: 993.895,
    y1: 188.396,
    x2: 999.266,
    y2: 188.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(962.975 226.989) scale(6.37515 6.37513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1016.75 226.989) scale(6.37515 6.37513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#C9CACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ADAEB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#898D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5E6669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#465053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2809_24943",
    x1: 1032.33,
    y1: 165.094,
    x2: 1040.93,
    y2: 165.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCC7C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#BDB8B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E0E1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#B1AEAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#A7A3A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2809_24943",
    x1: 256.231,
    y1: 273.527,
    x2: 255.768,
    y2: 306.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2809_24943",
    x1: 260.83,
    y1: 278.775,
    x2: 260.504,
    y2: 301.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2809_24943",
    x1: 547.959,
    y1: 142.646,
    x2: 549.349,
    y2: 196.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2809_24943",
    x1: 548.191,
    y1: 151.664,
    x2: 549.169,
    y2: 189.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2809_24943",
    x1: 309.207,
    y1: 158.593,
    x2: 309.851,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2809_24943",
    x1: 321.099,
    y1: 158.593,
    x2: 321.751,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2809_24943",
    x1: 332.99,
    y1: 158.593,
    x2: 333.642,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2809_24943",
    x1: 344.883,
    y1: 158.593,
    x2: 345.535,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2809_24943",
    x1: 356.786,
    y1: 158.593,
    x2: 357.438,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2809_24943",
    x1: 368.678,
    y1: 158.593,
    x2: 369.33,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2809_24943",
    x1: 380.567,
    y1: 158.593,
    x2: 381.219,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2809_24943",
    x1: 392.467,
    y1: 158.593,
    x2: 393.11,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2809_24943",
    x1: 404.358,
    y1: 158.593,
    x2: 405.01,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2809_24943",
    x1: 416.255,
    y1: 158.593,
    x2: 416.907,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2809_24943",
    x1: 428.155,
    y1: 158.593,
    x2: 428.798,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2809_24943",
    x1: 440.046,
    y1: 158.593,
    x2: 440.698,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2809_24943",
    x1: 451.939,
    y1: 158.593,
    x2: 452.591,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2809_24943",
    x1: 463.841,
    y1: 158.593,
    x2: 464.484,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2809_24943",
    x1: 475.734,
    y1: 158.593,
    x2: 476.386,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2809_24943",
    x1: 487.623,
    y1: 158.593,
    x2: 488.275,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2809_24943",
    x1: 499.523,
    y1: 158.593,
    x2: 500.166,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2809_24943",
    x1: 511.415,
    y1: 158.593,
    x2: 512.067,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2809_24943",
    x1: 523.311,
    y1: 158.593,
    x2: 523.963,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2809_24943",
    x1: 535.211,
    y1: 158.593,
    x2: 535.854,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2809_24943",
    x1: 547.102,
    y1: 158.593,
    x2: 547.754,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2809_24943",
    x1: 558.994,
    y1: 158.593,
    x2: 559.646,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2809_24943",
    x1: 570.896,
    y1: 158.593,
    x2: 571.54,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2809_24943",
    x1: 582.788,
    y1: 158.593,
    x2: 583.44,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2809_24943",
    x1: 594.681,
    y1: 158.593,
    x2: 595.334,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2809_24943",
    x1: 606.571,
    y1: 158.593,
    x2: 607.223,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2809_24943",
    x1: 618.47,
    y1: 158.593,
    x2: 619.123,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2809_24943",
    x1: 630.365,
    y1: 158.593,
    x2: 631.018,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2809_24943",
    x1: 642.257,
    y1: 158.593,
    x2: 642.909,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2809_24943",
    x1: 654.158,
    y1: 158.593,
    x2: 654.802,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2809_24943",
    x1: 666.05,
    y1: 158.593,
    x2: 666.702,
    y2: 183.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A3A2A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#525151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2809_24943",
    x1: 210.386,
    y1: 170.532,
    x2: 260.83,
    y2: 170.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2809_24943",
    x1: 258.702,
    y1: 170.517,
    x2: 300.368,
    y2: 170.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2809_24943",
    x1: 263.794,
    y1: 167.488,
    x2: 300.371,
    y2: 167.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(282.078 167.488) scale(15.393 15.393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2809_24943",
    x1: 280.67,
    y1: 162.003,
    x2: 300.491,
    y2: 162.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(290.581 162.003) scale(8.32284)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2809_24943",
    x1: 258.762,
    y1: 173.653,
    x2: 294.567,
    y2: 173.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.66 173.653) scale(15.0841 15.0841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2809_24943",
    x1: 258.762,
    y1: 179.932,
    x2: 277.441,
    y2: 179.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_2809_24943",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.097 179.932) scale(7.62786 7.62786)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#D7B189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#91562D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8D5027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541513"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInjectionUnit);
export default __webpack_public_path__ + "static/media/InjectionUnit.af118282527cb66c31f71646c30b0682.svg";
export { ForwardRef as ReactComponent };